// 公共与导航：简体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 公共基础词条
export const base = Object.freeze({
  "chatWorkbench.inboxChannels": "联系人分组",
  "chatWorkbench.personalContacts": "真人",
  "chatWorkbench.receptionContacts": "客服",
  "chatWorkbench.selfChat": "和自己聊天",
  "chatWorkbench.selfChatHint": "记录想法、备忘和待办",
  "chatWorkbench.pinConversation": "置顶",
  "chatWorkbench.unpinConversation": "取消置顶",
  "chatWorkbench.pinnedConversation": "已置顶",
  "chatWorkbench.conversationMenuHint": "右键或长按打开会话菜单，键盘可按Shift+F10",
  "chatWorkbench.back": "返回",
  "chatWorkbench.expandSheet": "展开聊天",
  "chatWorkbench.restoreSheet": "还原半窗",
  "chatWorkbench.agent.general": "客服 Agent",
  "chatWorkbench.agent.product": "商品 Agent",
  "chatWorkbench.agent.order": "订单咨询",
  "chatWorkbench.agent.supply_demand": "供需 Agent",
  "chatWorkbench.resizeSheet": "调整聊天窗口大小，当前{percent}%",
  "chatWorkbench.resizeSheetHint": "拖动顶部白条调整高度；点击依次切换80%、100%、80%、50%。也可使用上下方向键调整。",
  "clueDatasheet.notFound": "未找到该料号的规格书",
  "clueDatasheet.ambiguous": "该料号有多个品牌，请确认品牌后重试",
  "clueDatasheet.failed": "规格书加载失败，请稍后重试",

  "chatWorkbench.title": "消息工作台",
  "chatWorkbench.pin": "固定窗口，切页保持展开",
  "chatWorkbench.unpin": "取消固定，切页自动收纳",
  "chatWorkbench.conversations": "会话",
  "chatWorkbench.hideConversations": "收起会话列表",

  "workflowChatAgent.title": "只读群聊助手",
  "workflowChatAgent.progress": "查询进度",
  "workflowChatAgent.summary": "总结讨论",
  "workflowChatAgent.issues": "归纳问题",
  "workflowChatAgent.cancel": "取消任务",
  "workflowChatAgent.rangeHint": "基于本轮最近200条以内的消息与当前业务快照。",
  "workflowChatAgent.failedHint": "本次任务未完成，可重新发起查询。",
  "workflowChatAgent.unavailable": "智能助手暂不可用，请稍后重试。",
  "workflowChatAgent.messageEvidence": "消息依据",
  "workflowChatAgent.businessEvidence": "业务快照依据",
  "workflowChatAgent.evidenceMissing": "该依据暂不可用",
  "workflowChatAgent.status.READY": "排队中",
  "workflowChatAgent.status.RUNNING": "处理中",
  "workflowChatAgent.status.WAITING_RETRY": "等待重试",
  "workflowChatAgent.status.SUCCEEDED": "已完成",
  "workflowChatAgent.status.FAILED": "未完成",
  "workflowChatAgent.status.CANCELLED": "已取消",
  "workflowChatAgent.status.DEAD_LETTER": "重试已结束",
  "devUpdates.googleContinue": "使用 Google 账号继续",
  "common.language": "语言",
  "common.chinese": "简体中文",
  "common.english": "English",
  "common.login": "登录",
  "common.register": "注册",
  "common.logout": "退出",
  "common.agentService": "客服",
  "common.wechat": "微信",
  "common.backToTop": "回到顶部",
  "common.loading": "加载中...",
  "common.loginRequired": "请先登录",
  "common.downloadFailed": "下载文件失败",
  "common.unauthorizedGoods": "商品库接口未授权",
  "common.serverError": "服务器错误",
  "common.operationFailed": "操作失败",
  "common.requestError": "请求错误，请重试",
  "common.requestTimeout": "请求超时，请检查网络连接",
  "common.searchPlaceholder": "搜索料号、名称",
  "common.searchAction": "先搜一下",
  "nav.home": "首页",
  "nav.publish": "发布",
  "nav.featured": "精选",
  "nav.bidding": "竞标",
  "nav.supply": "供需",
  "nav.wiki": "百科",
  "nav.trade": "交易",
  "nav.ai": "先搜AI",
  "nav.mine": "我的",
  "nav.selfOperated": "自营",
  "nav.news": "资讯",
  "nav.priceChannel": "行情",
  "nav.brands": "品牌",
  "nav.bulkPublish": "大宗信息",
  "nav.featuredPublish": "精选商品",
  "nav.mobileBulkPublish": "大宗发布",
  "nav.mobileFeaturedPublish": "精选发布",
  "nav.quickNavigation": "首页快捷导航",
});

// 固定字段显示
// 本次 dev 合并新增的固定显示提示。
export const merged20261021 = Object.freeze({
  "devUpdates.oct23BulkPublish": "大宗商品发布",
  "devUpdates.oct23GoogleSignUp": "Google 注册",
  "devUpdates.oct23GoogleSignIn": "Google 登录",
  "devUpdates.oct23ShippingRemarkRequired": "不上传文件时，请填写发货备注",
  "devUpdates.oct23BuyerCommission": "买家佣金",
  "devUpdates.oct23PaymentDetails": "付款详情",
  "devUpdates.oct23PaymentAmount": "付款金额",
  "devUpdates.oct23CreditRepayment": "信用还款",
  "devUpdates.oct23CreditLimit": "信用额度",
  "devUpdates.oct23LinkedBusinessNumber": "关联业务单号",
  "devUpdates.oct23SellerSourcePrice": "卖方货源价格",
  "devUpdates.oct23PriceHistory": "历史价格信息",
  "devUpdates.oct23PreviousPrice": "原价",
  "devUpdates.oct23PreviousQuantity": "原数量",
  "devUpdates.oct23Repay": "去还款",
  "devUpdates.oct23ShippingProofUploaded": "发货凭证上传成功",
  "devUpdates.oct23ShippingProofFile": "发货凭证文件",
  "devUpdates.oct23ShippingRemark": "发货备注",
  "devUpdates.oct23ShipmentDetails": "发货详情",
  "devUpdates.oct23ChangedAmount": "变动金额",
  "devUpdates.oct23Agree": "同意",
  "devUpdates.oct23No": "否",
  "devUpdates.oct23ClaimedGoodsEditHint":
    "商品已有谈判人接单，请联系谈判人修改",
  "devUpdates.oct23ProductTotal": "商品总价",
  "devUpdates.oct23ProductTotalPrefix": "商品总金额：",
  "devUpdates.oct23SplitProduct": "商品拆单",
  "devUpdates.oct23SettleProduct": "商品结单",
  "devUpdates.oct23RecipientForm": "填写收货信息",
  "devUpdates.oct23RemarkDescription": "备注说明",
  "devUpdates.oct23ReviewDecision": "审核结果",
  "devUpdates.oct23ReviewHistory": "审核记录",
  "devUpdates.oct23WithdrawnAmount": "已提现金额",
  "devUpdates.oct23ConfirmedPurchaseIntention": "已确认购买意向单",
  "devUpdates.oct23PlatformPassword": "平台登录密码",
  "devUpdates.oct23TotalPayable": "应付总价",
  "devUpdates.oct23Bank": "开户行",
  "devUpdates.oct23BankName": "开户行名称",
  "devUpdates.oct23AvailableWithdrawalBalance": "当前可提现余额",
  "devUpdates.oct23BuyerRevisionPending": "待买家修改购买意向单",
  "devUpdates.oct23IntentionRevisionPending": "待修改购买意向单",
  "devUpdates.oct23IntentionConfirmationPending": "待确认购买意向单",
  "devUpdates.oct23SellerIntentionPending": "待货主确认购买意向单",
  "devUpdates.oct23CreditOutstanding": "待还信用金额",
  "devUpdates.oct23OptionalWechat": "微信号（选填）",
  "devUpdates.oct23SplitQuantity": "拆单数量",
  "devUpdates.oct23Claim": "接单",
  "devUpdates.oct23Claimed": "接单成功",
  "devUpdates.oct23IdentityPhotoHint": "提交本人有效身份证件照片",
  "devUpdates.oct23SubmitIntentionPrice": "提交购买意向单价格",
  "devUpdates.oct23WithdrawalReview": "提现审核",
  "devUpdates.oct23WithdrawalHistory": "提现明细",
  "devUpdates.oct23WithdrawalReference": "提现流水号",
  "devUpdates.oct23WithdrawalStatus": "提现状态",
  "devUpdates.oct23WithdrawalSubmitted": "提现申请已提交",
  "devUpdates.oct23WithdrawalIdProofRequired":
    "提现记录缺少 ID，无法提交付款凭证",
  "devUpdates.oct23WithdrawalIdReviewRequired": "提现记录缺少 ID，无法提交审核",
  "devUpdates.oct23WithdrawalIdReceiptRequired":
    "提现记录缺少 ID，无法确认收款",
  "devUpdates.oct23WithdrawalDetails": "提现详情",
  "devUpdates.oct23WithdrawalAmount": "提现金额",
  "devUpdates.oct23ExpenseHistory": "支出明细",
  "devUpdates.oct23ExpenseDetails": "支出明细详情",
  "devUpdates.oct23PayeeName": "收款人姓名",
  "devUpdates.oct23WholeOrderHint": "整单提交，无需选择规格",
  "devUpdates.oct23Yes": "是",
  "devUpdates.oct23WholeOrder": "是否整单",
  "devUpdates.oct23NoProofOrRemark": "暂无上传凭证或备注",
  "devUpdates.oct23NoChildProducts": "暂无子商品数据",
  "devUpdates.oct23NoReviewHistory": "暂无审核记录",
  "devUpdates.oct23NoSpecifications": "暂无规格数据",
  "devUpdates.oct23RecentWithdrawals": "最近五条提现申请及处理进度",
  "devUpdates.oct23SettlementHint": "查看关联订单并填写本次结单金额",
  "devUpdates.oct23Reference": "流水号",
  "devUpdates.oct23OverseasDocumentHint":
    "海外用户可使用护照或当地政府签发的身份证件",
  "devUpdates.oct23CurrentPrice": "现价",
  "devUpdates.oct23ContractPrice": "生成合同价格",
  "devUpdates.oct23RequestWithdrawal": "申请提现",
  "devUpdates.oct23SupervisorInspector": "监督人和验货人",
  "devUpdates.oct23ConfirmClaim": "确定接单",
  "devUpdates.oct23ConfirmIntentionPrice": "确认意向单价格",
  "devUpdates.oct23ReceiptConfirmed": "确认收款成功",
  "devUpdates.oct23ConfirmRepayment": "确认还款",
  "devUpdates.oct23Settle": "结单",
  "devUpdates.oct23Settled": "结单成功",
  "devUpdates.oct23SettlementAmount": "结单金额",
  "devUpdates.oct23SettlementExceedsTotal": "结单金额不能超过商品总金额",
  "devUpdates.oct23ProductIdRequired": "缺少商品ID，无法查询关联订单",
  "devUpdates.oct23VerificationRegion": "认证地区",
  "devUpdates.oct23SplitWholeOrderUnavailable": "该商品已拆分，不可整单",
  "devUpdates.oct23GoogleBindingHint":
    "该邮箱已有平台账号，请输入原平台登录密码以绑定 Google。",
  "devUpdates.oct23ShippingProofOrRemarkRequired":
    "请上传发货凭证文件或填写发货备注",
  "devUpdates.oct23IdentityPhotoRequired": "请上传证件照片",
  "devUpdates.oct23IdentityBackRequired": "请上传身份证国徽面",
  "devUpdates.oct23PurchaseOrderRequired": "请先完成采购订单",
  "devUpdates.oct23ConfirmWithdrawalReceipt":
    "请确认提现款项已经到账，确认后状态将更新为已到账。",
  "devUpdates.oct23ContactNegotiator": "请联系谈判人修改",
  "devUpdates.oct23EnterSwiftCode": "请输入 Swift Code",
  "devUpdates.oct23EnterBuyerMobile": "请输入买家手机号",
  "devUpdates.oct23EnterProductTotal": "请输入商品总金额",
  "devUpdates.oct23RepaymentMinimum": "请输入大于 100 的还款金额",
  "devUpdates.oct23EnterBankName": "请输入开户行名称",
  "devUpdates.oct23EnterWithdrawalAmount": "请输入提现金额",
  "devUpdates.oct23EnterPayeeName": "请输入收款人姓名",
  "devUpdates.oct23EnterRecipientAddress": "请输入收货地址",
  "devUpdates.oct23EnterRecipientPhone": "请输入收货电话",
  "devUpdates.oct23EnterOwnMobile": "请输入本人常用手机号",
  "devUpdates.oct23EnterOwnEmail": "请输入本人常用邮箱",
  "devUpdates.oct23InvalidSettlement": "请输入正确的结单金额",
  "devUpdates.oct23EnterCurrentPrice": "请输入现价",
  "devUpdates.oct23EnterSettlement": "请输入结单金额",
  "devUpdates.oct23BalanceHistoryHint": "账户余额变动与资金流向记录",
  "devUpdates.oct23SellerCommission": "货主佣金",
  "devUpdates.oct23FundDirection": "资金方向",
  "devUpdates.oct23FollowDetails": "跟单详情",
  "devUpdates.oct23TransferProof": "转账凭证",
  "devUpdates.oct23Repaid": "还款成功",
  "devUpdates.oct23RepaymentAmount": "还款金额",
  "devUpdates.oct23SelectWithdrawalCurrency": "选择提现币种",
  "devUpdates.oct23SelectSettlementUnit": "选择结单金额单位",
  "devUpdates.oct23ReconnectGoogle": "重新连接 Google",
  "devUpdates.oct23AmountType": "金额类型",
  "devUpdates.oct23VerifyExistingAccount": "验证已有平台账号",
  "devUpdates.oct23VerifyAndSignIn": "验证并登录",
  "devUpdates.oct23ProofFormatsHint":
    "（支持图片、视频等文件，文件或备注至少填写一项）",
  "devUpdates.oct23PurchaseOrderIncomplete": "（采购订单未完成）",
  "devUpdates.oct23GoogleVerifying": "正在验证 Google 账号…",
  "devUpdates.oct23GoogleConnecting": "正在连接 Google…",
  "devUpdates.oct23GoogleVerifyingShort": "正在验证 Google 账号",
  "devUpdates.oct23GoogleConnectingShort": "正在连接 Google",
  "devUpdates.oct23GoogleConfigUnavailable": "Google 登录配置暂不可用",
  "devUpdates.oct23GoogleInitializationFailed": "Google 登录初始化失败",
  "devUpdates.oct23GoogleLoginFailed": "Google 登录失败，请重试",
  "devUpdates.oct23ClaimFailed": "接单失败",
  "devUpdates.oct23ClaimRetry": "接单失败，请稍后重试",
  "devUpdates.oct23OwnMobile": "本人手机号",
  "devUpdates.oct23VerifyIdentityInstructions":
    "请验证{method}并上传本人有效身份证件，确保填写信息与证件一致。",
  "devUpdates.oct23IdentityVerificationCompletion":
    "{method}校验通过后完成实名认证",
  "devUpdates.oct23DocumentPage": "证件资料页",
  "devUpdates.oct23DocumentPageHint": "包含姓名、照片与证件号码的一面",
  "devUpdates.oct23UploadDocumentPage": "上传证件资料页",
  "devUpdates.oct23OptionalDocumentBack": "证件背面（选填）",
  "devUpdates.oct23DocumentBackHint": "证件存在背面信息时请上传",
  "devUpdates.oct23UploadDocumentBack": "上传证件背面",
  "devUpdates.oct23DocumentNumber": "证件号码",
  "devUpdates.oct23EnterOverseasDocument": "请输入护照或当地身份证件号码",
  "devUpdates.oct23EnterEmailCode": "请输入4位邮箱验证码",
  "devUpdates.oct23EmailCodeRequired": "请填写4位邮箱验证码",
  "devUpdates.oct23SmsCodeRequired": "请填写4位短信验证码",
  "devUpdates.oct23VerificationDocumentInvalid": "请输入正确的证件号码",
  "devUpdates.oct23MobileInvalid": "请填写正确的手机号码",
  "devUpdates.oct23EmailInvalid": "请填写正确的邮箱",
  "devUpdates.oct23BackOptional": "背面可选",
  "devUpdates.oct23EmailSent": "邮件已发送，请注意查收",
  "devUpdates.oct23SmsSent": "短信已发送，请注意查收",
  "devUpdates.oct23WithdrawalUnderReview": "提现审核中",
  "devUpdates.oct23NormalAmount": "正常金额",
  "devUpdates.oct23UnknownBusiness": "未知业务",
  "devUpdates.oct23UnknownDirection": "未知方向",
  "devUpdates.oct23ProductSale": "商品出售",
  "devUpdates.oct23SelfDeposit": "自身充值",
  "devUpdates.oct23SystemGrant": "系统赠送",
  "devUpdates.oct23ProductPurchase": "购买商品",
  "devUpdates.oct23BalanceWithdrawal": "余额提现",
  "devUpdates.oct23SelectReview": "请选择审核结果",
  "devUpdates.oct23EnterRepayment": "请输入还款金额",
  "devUpdates.oct23SelectWithdrawalCurrencyRequired": "请选择提现币种",
  "devUpdates.oct23FileUploading": "文件上传中",
  "devUpdates.shippingManagement": "发货管理",
  "devUpdates.createdBankSelectionRequired":
    "银行已创建，但未能识别新银行，请点击更换重新选择",
  "shipping.title": "订单发货",
  "shipping.supplierIntro": "填写订单商品本批发货数量和物流信息",
  "shipping.completed": "发货完成",
  "shipping.intro": "选择入仓号和出库单，填写本批数量和物流信息",
  "shipping.orderQuantity": "订单数量",
  "shipping.sentQuantity": "已发数量",
  "shipping.remainingQuantity": "待发数量",
  "shipping.historicalWarning": "该订单已有历史物流，请核对原已发数量。",
  "shipping.batchTitle": "第{sequence}批发货",
  "shipping.pending": "待发货",
  "shipping.partial": "部分发货",
  "shipping.complete": "全部发货",
  "shipping.shipped": "已发货",
  "shipping.deleteDraft": "删除草稿",
  "shipping.addWarehouse": "添加入仓号",
  "shipping.deleteRow": "删除此行",
  "shipping.warehouseNumber": "入仓号",
  "shipping.outboundOrder": "出库单",
  "shipping.noMatches": "无匹配数据",
  "shipping.warehouseSearch": "请输入入仓号搜索",
  "shipping.outboundSearch": "请输入出库单搜索",
  "shipping.sourceHint":
    "选择入仓号或出库单后自动关联另一栏；本次发货默认填入可发数量，可修改，不发的商品留空。",
  "shipping.sourceEmpty": "该入仓号与出库单暂无商品明细。",
  "shipping.requestedQuantity": "申请出库数量",
  "shipping.availableQuantity": "剩余可发货数量",
  "shipping.thisShipment": "本次发货",
  "shipping.enterQuantity": "填写数量",
  "shipping.reselectDraft": "请为原草稿重新选择一组入仓号与出库单后保存。",
  "shipping.enterRecipient": "请输入收货人",
  "shipping.enterPhone": "请输入联系电话",
  "shipping.enterAddress": "请输入详细收货地址",
  "shipping.enterCompany": "请输入物流公司",
  "shipping.enterTracking": "请输入物流单号",
  "shipping.proofOrRemark": "发货凭证 / 备注",
  "shipping.oneRequired": "至少填写一项",
  "shipping.remarkPlaceholder": "填写发货说明，或在下方上传凭证",
  "shipping.uploadProof": "上传凭证",
  "shipping.proofFormats": "JPG、PNG、PDF，最多10个",
  "shipping.addBatch": "添加发货（下一批）",
  "shipping.allShipped": "订单商品已全部发货",
  "shipping.submitLocks": "提交后，本批信息不可修改",
  "shipping.readOnly": "已发批次仅支持查看",
  "shipping.submitBatch": "提交本批发货",
  "shipping.queryUnavailable": "查询服务不可用，请核对接口地址或部署状态",
  "shipping.queryFailed": "查询失败，请重新搜索",
  "shipping.orderMissing": "缺少订单编号，无法建立发货记录",
  "shipping.loadFailed": "加载发货信息失败",
  "shipping.submitCurrent": "请先提交当前批次，再添加下一批发货",
  "shipping.sourceDuplicate": "该入仓号与出库单已添加，请选择其他组合",
  "shipping.sourceRequired": "请重新选择一组入仓号与出库单后保存",
  "shipping.saveFailed": "发货保存失败，请重试",
  "shipping.cleanupFailed": "发货已保存，但本地草稿清理失败，请刷新页面",
  "shipping.saved": "本批发货已保存到服务器，信息已锁定",
  "shipping.draftSaved": "本地草稿已保存",
  "shipping.deleteConfirmation": "确定删除当前草稿？已发货记录不受影响。",
  "shipping.unsavedConfirmation": "当前批次有未保存修改，是否保存草稿后关闭？",
  "shipping.unsavedChanges": "未保存的修改",
  "shipping.saveAndClose": "保存并关闭",
  "shipping.discard": "放弃修改",
  "shipping.records": "分批发货记录",
  "shipping.loading": "发货记录加载中...",
  "shipping.historyFailed": "发货记录加载失败",
  "shipping.goodsWarehouse": "商品入仓号",
  "shipping.sourceOutbound": "来源出库单",
  "shipping.quantity": "发货数量",
  "shipping.receiverInfo": "收货信息：",
  "shipping.logisticsInfo": "物流信息：",
  "shipping.buyerCompany": "买方公司：",
  "shipping.warehousePrefix": "入仓号：",
  "shipping.orderPrefix": "订单号：",
  "shipping.remarkPrefix": "备注：",
  "shipping.allocatedExceeded":
    "{name}本批合计 {quantity} {unit}，超过待发数量 {remaining}",
  "shipping.sold": "已售",
  "shipping.viewDatasheet": "查看规格书",
  "shipping.businessReview": "添加业务审批",
  "shipping.outboundReviewers": "出库单审核人",
  "devUpdates.rejectInspectionsInBulk": "批量驳回",
  "devSync.priceMaxDecimals": "最多4位小数",
  "devSync.priceRequired": "请填写价格或金额",
  "devSync.nonnegativePrice": "请填写大于或等于0的值",
  "devSync.searchWarehouseReceipt": "请输入入仓号搜索",
  "devSync.noMatchingWarehouseReceipt": "暂无匹配入仓号",
  "devSync.warehouseReceiptSearchFailed": "查询失败，请重新输入入仓号重试",
  "devSync.receivedWarehouse": "入仓仓库",
  "devSync.savedInspectionReloadFailed":
    "保存成功，明细刷新失败，请刷新页面后继续操作",
  "devSync.deleteReceiptDetailConfirmation":
    "删除后该入仓明细及对应的验货细节将一起删除，确认删除吗？",
});

export const formDisplay = Object.freeze({
  "devSync.usdCurrencyLabel": "$(美元)",
  "devSync.videos": "视频",
  "devSync.manufacturer": "产品厂家",
  "devSync.productParameters": "产品参数",
  "devSync.productDimensions": "产品尺寸",
  "devSync.productQuantityAndUnit": "产品数量和单位",
  "devSync.productNumber": "产品编号",
  "devSync.productCode": "产品编码",
  "devSync.productWeight": "产品重量",
  "devSync.certificateOfOrigin": "产地证明",
  "devSync.conversationRenamed": "会话名称已修改",
  "devSync.deep": "低沉",
  "devSync.multiplierSymbol": "倍",
  "devSync.questionsRemainingWithoutSigningIn": "免登录还可提问",
  "devSync.receivedStock": "入仓库存",
  "devSync.closeVoiceSettings": "关闭声音设置",
  "devSync.dispatchWarehouse": "出库仓库",
  "devSync.dispatchOrderInformation": "出库单信息",
  "devSync.dispatchOrderNumber": "出库单号",
  "devSync.dispatchOrderReview": "出库单审核",
  "devSync.dispatchOrderReviewer": "出库单审核人",
  "devSync.dispatchQuantity": "出库数量",
  "devSync.dispatchDate": "出库日期",
  "devSync.dispatchDetails": "出库明细",
  "devSync.dispatchAttachments": "出库附件",
  "devSync.deleteReceiptAndInspectionDetails": "删除入仓记录及验货细节",
  "devSync.deleteAttachment": "删除附件",
  "devSync.addedToCart": "加入购物车成功",
  "devSync.semitones": "半音",
  "devSync.publicationType": "发布类型",
  "devSync.priceCurrency": "商品价格货币单位",
  "devSync.imagesOrVideosAreUploadingPleaseWait":
    "图片或视频上传中，请稍后操作",
  "devSync.failedToReadTheImage": "图片读取失败",
  "devSync.loadingVoices": "声音加载中…",
  "devSync.voiceSettings": "声音设置",
  "devSync.bulkPublicationIsComingSoon": "大宗发布功能正在准备中，敬请期待",
  "devSync.approvalNumber": "审批编号",
  "devSync.thisBrowserDoesNotSupportRecording": "当前浏览器不支持录音",
  "devSync.thisBrowserDoesNotSupportPitchAdjustment":
    "当前浏览器不支持音高调节",
  "devSync.theCameraIsUnavailableInThisBrowserSwitchedToTheSystemCamera":
    "当前浏览器无法直接调用相机，已切换到系统拍照",
  "devSync.fast": "快",
  "devSync.restoreDefaults": "恢复默认",
  "devSync.slow": "慢",
  "devSync.department": "所在部门",
  "devSync.holdTheVoiceButtonBelowToSpeak": "按住下方语音按钮即可说话",
  "devSync.multipleFilesSupported": "支持上传多个文件",
  "devSync.filesAreUploadingPleaseWaitBeforeSwitchingProducts":
    "文件上传中，请稍后切换商品",
  "devSync.createProductInformation": "新建产品信息",
  "devSync.microphonePermissionUnavailable": "无法获取麦克风权限",
  "devSync.bright": "明亮",
  "devSync.noDispatchDetails": "暂无出库明细",
  "devSync.noSpeechDetectedPleaseTryAgain": "未识别到语音内容，请重试",
  "devSync.keptDuringThisVisitSignInToSave": "本次浏览期间保留，登录后可保存",
  "devSync.timesKeptDuringThisVisitSignInToSave":
    "次 · 本次浏览期间保留，登录后可保存",
  "devSync.loadingInformation": "正在加载资料…",
  "devSync.addDetails": "添加明细",
  "devSync.clickOrDragFilesToUpload": "点击或拖拽上传附件",
  "devSync.failedToCaptureAPhotoPleaseTryAgain": "照片生成失败，请重新拍照",
  "devSync.signInToViewConversationHistory": "登录后查看会话历史",
  "devSync.theCameraIsNotReadyPleaseTryAgainLater":
    "相机尚未准备好，请稍后重试",
  "devSync.cameraPermissionUnavailableSwitchedToTheSystemCamera":
    "相机权限不可用，已切换到系统拍照",
  "devSync.chipType": "芯片类型",
  "devSync.thisReceiptIsSavedDeletingItAlsoDeletesItsInspectionDetailsContinue":
    "该入仓记录已保存，删除后对应的验货细节将一起删除，确认删除吗？",
  "devSync.speechSpeed": "语速",
  "devSync.voiceToolbar": "语音工具栏",
  "devSync.enterThePrimaryContact": "请填写主要联系人",
  "devSync.enterTheManufacturer": "请填写厂家名称",
  "devSync.enterTheDateCodeDc": "请填写批次(DC)",
  "devSync.enterAtLeastOneValidReceivedQuantity":
    "请填写至少一条有效的入仓数量",
  "devSync.searchByProductName": "请输入产品名称搜索",
  "devSync.enterTheProductCode": "请输入产品编码",
  "devSync.enterReceivedStock": "请输入入仓库存",
  "devSync.enterTheDispatchOrderNumber": "请输入出库单号",
  "devSync.enterDispatchOrderNotes": "请输入出库单相关说明",
  "devSync.enterTheDispatchQuantity": "请输入出库数量",
  "devSync.enterAnAlternativeBrand": "请输入替代品牌",
  "devSync.enterAnAlternativePartNumber": "请输入替代料号",
  "devSync.selectAPdfFileOrImage": "请选择 PDF 文件或图片",
  "devSync.selectAWarehouseReceiptNumber": "请选择入仓号",
  "devSync.selectADispatchWarehouse": "请选择出库仓库",
  "devSync.selectADispatchDate": "请选择出库日期",
  "devSync.informationIsTemporarilyUnavailable": "资料暂时无法加载",
  "devSync.carouselImage": "轮播图片",
  "devSync.selectDispatchWarehouse": "选择出库仓库",
  "devSync.selectDispatchDate": "选择出库日期",
  "devSync.selectAVoice": "选择声音",
  "devSync.linkOrId": "链接或id",
  "devSync.attachmentsAndNotes": "附件与备注",
  "devSync.pitch": "音高",
  "devSync.rejectSalesOrder": "驳回销售单",
  "devSync.verificationIsNotIntegratedYetEnterAnyFourDigits":
    "验证码暂未接入，先填任意4位数字",
  "devSync.recipient": "收货人",
  "devSync.recipientPhone": "收货电话",
  "devSync.loginFailedCheckYourAccountDetails": "登录失败，请检查账号信息",
  "devSync.turnOffAutomaticSpeech": "关闭自动播报",
  "devSync.turnOnAutomaticSpeech": "开始自动播报",
  "devSync.readReplyAloud": "朗读回复",
  "devSync.playGeneratedSpeech": "播放已生成的语音",
  "devSync.generatingSpeechClickToCancel": "生成语音中，点击取消",
  "devSync.stopReadingAloud": "停止朗读",
  "devSync.awaitingSupervisorConfirmation": "待监督确认",
  "devSync.notLoaded": "未加载",
  "devSync.noMatchingProducts": "暂无匹配商品",
  "devSync.searchFailedEnterYourQueryAgain": "搜索失败，请重新输入重试",
  "devSync.retrievedFilesDocumentsSnippetsSnippets":
    "检索到 {files} 份资料 · {snippets} 个片段",
  "devSync.failedToLoadVoicesPleaseTryAgain": "声音列表加载失败，请重试",
  "devSync.failedToGenerateSpeechPleaseTryAgain": "语音生成失败，请重试",
  "devSync.snippetWarning": "仅相关片段送入模型上下文，检索命中不代表最终引用",
  "devSync.candidateWarning": "候选资料已送入模型上下文，不代表最终引用",
});

// 目录固定标签
export const catalogDisplay = Object.freeze({
  "devOct15.aiLoading": "先搜AI加载中…",
  "devOct15.conversationToolbar": "对话主题和语音工具栏",
  "devOct15.aiConnecting": "正在连接 AI 助手…",
  "devOct15.moreSeller": "更多卖家资料",
  "devOct15.standardDisclaimer":
    "参数来源：题库标准答案。说明内容由 AI 根据参数生成，待确认；通用建议不代表该型号规格书结论。",
  "devOct15.viewWiki": "查看百科资料",
  "devOct15.modules": "存储器模块",
  "devOct15.controllers": "存储器接口 / 控制器",
  "devOct15.nonvolatile": "非易失存储器",
  "devOct15.otherMemory": "其他存储器",
});

// 系统反馈
export const systemFeedback = Object.freeze({
  "devUpdates.startAConversationWithName": "开始与{name}的对话",
  "devUpdates.sending": "发送中...",
  "devUpdates.failedToSend": "发送失败",
  "devUpdates.typeAMessage": "输入消息...",
  "devUpdates.loadingProducts": "正在加载产品…",
  "devUpdates.businessLicenseValidity": "营业执照有效期",
  "devUpdates.saving": "保存中...",
  "devUpdates.collapseInput": "收起输入框",
  "devUpdates.expandInput": "展开输入框",
  "devUpdates.cameraPreview": "相机取景",
  "devUpdates.confirmCapturedPhoto": "确认拍摄照片",
  "devUpdates.recognizeAPhoto": "拍照识别",
  "devUpdates.confirmPhoto": "确认照片",
  "devUpdates.releaseToCancel": "松手取消",
  "devUpdates.releaseToSendSlideUpToCancel": "松手发送，上移取消",
  "devUpdates.linked": "已绑定",
  "devUpdates.notLinked": "待绑定",
  "devUpdates.hideSellerInformation": "收起卖方信息",
  "devUpdates.moreSellerInformation": "查看更多卖方信息",
  "devUpdates.hideBuyerInformation": "收起买方信息",
  "devUpdates.moreBuyerInformation": "查看更多买方信息",
  "devUpdates.orderReviewer": "订单审核人",
  "devUpdates.contractReviewer": "合同审核人",
  "devUpdates.supplierAttachments": "供应商附件",
  "devUpdates.hideSalesOrderInformation": "收起销售订单信息",
  "devUpdates.hidePurchaseOrderInformation": "收起采购订单信息",
  "devUpdates.morePurchaseOrderInformation": "更多采购订单信息",
  "devUpdates.hideAdditionalInformation": "收起更多信息",
  "devUpdates.showAdditionalInformation": "展开更多信息",
  "devUpdates.noTaxId": "暂无税号",
  "devUpdates.productNotSpecified": "未填写产品",
  "devUpdates.noPersonInCharge": "暂无负责人",
  "devUpdates.asAgreed": "按商定",
  "devUpdates.seller": "货主：",
  "devUpdates.orderTotalExceeded": "订单总额超出",
  "devUpdates.orderTotalUnpaid": "订单总额未支付",
  "devUpdates.hongKongAccount": "香港账户",
  "devUpdates.mainlandChinaAccount": "境内账户",
  "devUpdates.secondsBeforeResending": "秒后重新发送",
  "devUpdates.noApprovalNotes": "暂无审批备注",
  "devUpdates.previouslyTraded": "交易过",
  "devUpdates.noPreviousTrades": "未交易",
  "devUpdates.ordinalPrefix": "第",
  "devUpdates.installment": "期",
  "devUpdates.searchReviewers": "搜索审核人",
  "devUpdates.reviewer": "审核人",
  "devUpdates.uploadThisInstallmentsPaymentReceipt": "上传本期支付凭证",
  "devUpdates.confirmed": "（已确认）",
  "devUpdates.unconfirmed": "（未确认）",
  "devUpdates.uploadPaymentMethodAttachments": "付款方式附件上传",
  "devUpdates.bidClosingReview": "截标审核",
  "devUpdates.publicationInformation": "发布信息",
  "devUpdates.bidClosingInformation": "截标信息",
  "devUpdates.singlePublication": "单条发布",
  "devUpdates.biddingReviewDetails": "竞标审核明细",
  "devUpdates.bidClosingReviewDetails": "截标审核明细",
  "devUpdates.saveInspectionRecord": "保存验货记录",
  "devUpdates.inspectionReview": "验货审核",
  "devUpdates.confirmInspectionsInBulk": "批量确认验货",
  "devUpdates.confirmInspection": "确认验货",
  "devUpdates.uploadedDocuments": "已上传资料",
  "devUpdates.generatingWikiContent": "正在生成百科内容...",
  "devUpdates.aiWikiQA": "AI 百科问答",
  "devUpdates.wikiQA": "百科问答",
  "devUpdates.qAEntries": "条问答",
  "devUpdates.discussions": "个讨论",
  "devUpdates.generatingQAFromWikiSections": "正在根据百科栏目生成问答…",
  "devUpdates.basedOnSpecificationsTechnicalFeaturesApplicationsAndPrecautions":
    "依据规格说明、技术特点、应用领域和使用注意事项",
  "devUpdates.noDiscussionsForThisProductPopularQAIsShownInstead":
    "暂未找到该产品讨论，正在展示热门问答",
  "devUpdates.currentProductDiscussions": "当前产品讨论",
  "devUpdates.reviewPaymentReceipt": "审核付款凭证",
  "devUpdates.reviewPaymentMethod": "审核付款方式",
  "devUpdates.selectPaymentMethod": "选择付款方式",
  "devUpdates.paymentReceiptReviewer": "付款凭证审核人",
  "devUpdates.paymentMethodReviewer": "付款方式审核人",
  "devUpdates.onlyJpgPngGifAndBmpImagesAreSupported":
    "只支持jpg、png、gif、bmp格式的图片",
  "devUpdates.imagesMustNotExceed10Mb": "图片大小不能超过10M",
  "devUpdates.onlyImagesAreSupported": "只支持图片",
  "devUpdates.imageSizeLimit": "图片不能超过10M",
  "devUpdates.selectAnImageOrEnterTextFirst": "请先选择图片或输入文字信息",
  "devUpdates.requestFailed": "接口请求失败",
  "devUpdates.theImagePickerIsNotReady": "图片选择组件未加载",
  "devUpdates.onlyPdfPngAndJpgFilesAreSupported":
    "只支持pdf、png、jpg格式的文件",
  "devUpdates.filesMustNotExceed10Mb": "文件大小不能超过10M",
  "devUpdates.onlyPngAndJpgImagesAreSupported": "只支持png、jpg格式的图片",
  "devUpdates.recognitionSucceeded": "识别成功 ✅",
  "devUpdates.copied": "已复制",
  "devUpdates.productLinkedSuccessfully": "绑定商品成功!",
  "devUpdates.thisPageSupportsPurchaseOrderAndPurchaseContractReviewOnly":
    "当前页面仅支持采购订单审核和采购合同审批",
  "devUpdates.failedToLoadApprovalStatus": "获取审批节点状态失败",
  "devUpdates.uploadTheContractFileFirst": "请先上传合同文件",
  "devUpdates.theContractFileIsUnchangedNoUploadIsNeeded":
    "合同文件未发生变更，无需上传",
  "devUpdates.relatedContentUpdated": "关联内容已更新",
  "devUpdates.removedSuccessfully": "移除成功",
  "devUpdates.contractApprovalRequested": "发起合同审批成功",
  "devUpdates.enterTheRejectionReason": "请填写驳回理由",
  "devUpdates.unsupportedDownloadResponse": "无法识别的下载响应类型",
  "devUpdates.fileDownloaded": "文件下载完成",
  "devUpdates.downloadFailedTheServerReturnedAnError":
    "下载失败，服务器返回了错误",
  "devUpdates.paymentApproved": "付款审核成功",
  "devUpdates.paymentRequestRejected": "付款申请已驳回",
  "devUpdates.contractIdIsMissing": "缺少合同ID参数",
  "devUpdates.failedToLoadContractData": "加载合同数据失败",
  "devUpdates.theCustomerUploadedASingleStampedContractThisOptionCannotBeChanged":
    "客户已上传单章合同文件，不能再切换该选项",
  "devUpdates.chooseEitherAContractTemplateOrASingleStampedContractForApproval":
    "合同模板和单章合同只能选择一种发起审批",
  "devUpdates.uploadAContractTemplateOrASingleStampedContractFirst":
    "请先上传合同模板或单章合同",
  "devUpdates.theTemplateIsEmpty": "模板内容为空",
  "devUpdates.templateSaved": "模板已保存",
  "devUpdates.failedToSaveTemplate": "模板保存失败",
  "devUpdates.thisReviewerHasAlreadyBeenAdded": "该审核人已添加",
  "devUpdates.uploadTheInvInvoiceFirst": "请先上传INV发票",
  "devUpdates.invApprovalRequested": "发起INV审批成功",
  "devUpdates.invApproved": "INV审核成功",
  "devUpdates.failedToInitializeTheSellerCompany": "初始化货主公司失败",
  "devUpdates.bankAddedSuccessfully": "银行添加成功",
  "devUpdates.imageFileSizeLimit": "图片大小不能超过10MB",
  "devUpdates.relatedContentRemoved": "已移除关联内容",
  "devUpdates.paymentApprovalRequested": "发起付款审批成功",
  "devUpdates.mergedSuccessfully": "合并成功",
  "devUpdates.failedToSearchCompanies": "搜索公司列表失败",
  "devUpdates.failedToLoadCompanies": "获取公司列表失败",
  "devUpdates.companyProfileAdded": "公司资料添加成功",
  "devUpdates.addressAdded": "地址添加成功",
  "devUpdates.addressChanged": "地址更换成功",
  "devUpdates.enterASearchKeywordFirst": "请先输入搜索关键词",
  "devUpdates.aSalesOrderCannotBeGeneratedForThisOrderYet":
    "当前订单暂不可生成销售订单",
  "devUpdates.selectAtLeastOneSellerReviewer": "请选择至少一个卖方审核人",
  "devUpdates.selectTheSellerCompany": "请选择卖方公司",
  "devUpdates.productConditionIsRequired": "货物情况必填",
  "devUpdates.validationFailedCheckTheFormFields": "表单验证失败，请检查输入项",
  "devUpdates.selectThePriceCurrency": "请选择产品价格单位",
  "devUpdates.orderContractGenerated": "订单合同生成成功",
  "devUpdates.orderIdIsMissingTheOrderCannotBeRejected": "缺少订单ID，无法驳回",
  "devUpdates.failedToLoadData": "加载数据失败",
  "devUpdates.installmentsCannotExceedTheAmountDue":
    "分批付款合计不能超过应付金额",
  "devUpdates.onlyOneUnpaidInstallmentCanBeAddedAtATime":
    "每次只能添加一期未支付的分期批次",
  "devUpdates.theUnpaidBalanceIsZeroNoMoreInstallmentsCanBeAdded":
    "未支付总额为0，不能继续添加分期",
  "devUpdates.upToFiveInstallmentsAreSupported": "最多支持5期分期付款",
  "devUpdates.enterTheFirstInstallmentAmountAndPaymentDate":
    "请填写第一期的付款金额和付款时间",
  "devUpdates.paymentMethodSubmittedForReview":
    "发起付款方式审批成功，开始付款方式审核",
  "devUpdates.uploadAPaymentReceipt": "请上传支付凭证",
  "devUpdates.submittedToPurchasingTeam": "提交成功，已流转至采购商务：黄心雨",
  "devUpdates.paymentReceiptConfirmed": "付款凭证已确认",
  "devUpdates.paymentMethodApproved": "付款方式审核通过",
  "devUpdates.enterAValidMobileVerificationCode": "请输入正确的手机验证码",
  "devUpdates.areYouSureYouWantToLogOut": "你确认要退出登录吗？",
  "devUpdates.logoutCancelled": "已取消退出",
  "devUpdates.linkedSuccessfully": "绑定成功",
  "devUpdates.bankDetailsCopied": "银行信息已复制",
  "devUpdates.failedToLoadBanks": "银行列表加载失败",
  "devUpdates.linkedBanksUpdated": "绑定银行已更新",
  "devUpdates.failedToUpdateLinkedBanks": "绑定银行更新失败",
  "devUpdates.failedToLoadSuppliers": "供应商列表加载失败",
  "devUpdates.failedToLoadSupplierProfile": "供应商资料加载失败",
  "devUpdates.bankCreated": "新建银行成功",
  "devUpdates.failedToLoadBiddingInformation": "加载竞标信息失败",
  "devUpdates.selectACompanyFirst": "请先选择公司名称",
  "devUpdates.bankDetailsAddedAndFilledInAutomatically":
    "银行资料已新增并自动回填",
  "devUpdates.failedToAddCompany": "添加公司失败",
  "devUpdates.batchUploadIsComingSoon": "批量上传功能开发中",
  "devUpdates.selectTheProductLocation": "请选择所货地",
  "devUpdates.selectThePublicationDate": "请选择发布时间",
  "devUpdates.selectTheBiddingDeadline": "请选择截标时间",
  "devUpdates.selectTheBidOpeningTime": "请选择开标时间",
  "devUpdates.uploadAnExcelFileFirst": "请先上传Excel文件",
  "devUpdates.batchPublicationFailedTryAgainLater": "批量发布失败，请稍后重试",
  "devUpdates.onlyXlsxAndXlsFilesAreSupported":
    "只支持 .xlsx 和 .xls 格式的文件",
  "devUpdates.cannotReadTheExcelWorksheet": "无法读取Excel工作表",
  "devUpdates.theExcelFileIsEmpty": "Excel文件为空",
  "devUpdates.theExcelFileContainsNoData": "Excel文件没有数据",
  "devUpdates.biddingImportPartNumberColumnRequired":
    '未找到有效的竞标数据，请确保Excel包含"料号"列',
  "devUpdates.failedToReadFile": "读取文件失败",
  "devUpdates.completeAtLeastOneField": "请至少填写一项信息",
  "devUpdates.selectPackaging": "请选择包装",
  "devUpdates.selectAPackage": "请选择封装",
  "devUpdates.uploadThisContractItCannotBeEditedAfterTheOtherPartyApprovesIt":
    "确认上传合同？上传后不能再修改编辑",
  "devUpdates.relatedOrdersAdded": "关联订单添加成功",
  "devUpdates.approveDualStampedContractConfirmation":
    "确认双章合同审核通过？",
  "devUpdates.dualStampedContractApproved": "双章合同审核通过",
  "devUpdates.requestInvApproval": "确认发起INV审批？",
  "devUpdates.operationSucceeded": "操作成功！",
  "devUpdates.completeTheRequiredFields": "请填写必填字段",
  "devUpdates.quoteSubmitted": "报价成功",
  "devUpdates.relatedOrderRemoved": "已移除关联订单",
  "devUpdates.aSingleOrderDoesNotNeedMerging": "单个订单不需要合并",
  "devUpdates.selectOrdersToMerge": "请选择需要合并的订单",
  "devUpdates.checkTheRequiredFields": "请检查必填项！",
  "devUpdates.submitThePaymentMethodForReview":
    "确认提交付款方式审批？提交后将进入审核流程。",
  "devUpdates.paymentReceiptRejected": "付款凭证已驳回",
  "devUpdates.confirmThePaymentReceiptIsCorrectTheSupplierCanThenViewAndDownloadIt":
    "确认付款凭证无误？确认后供应商可查看下载付款凭证",
  "devUpdates.approveThePaymentMethod": "确认通过付款方式审核？",
  "devUpdates.paymentMethodRejected": "付款方式已驳回",
  "devUpdates.enterTheBusinessEmail": "请输入企业邮箱",
  "devUpdates.enterTheAccountAndPassword": "请填写账号和密码",
  "devUpdates.readAndAcceptTheAgreements": "请阅读并同意相关协议",
  "devUpdates.thePasswordMustContain620Characters": "密码长度需为6-20位",
  "devUpdates.enterTheFullCompanyName": "请填写企业全称",
  "devUpdates.failedToLoadBiddingReviewData": "竞标审核数据读取失败",
  "devUpdates.failedToLoadReviewDetailsTryAgainLater":
    "审核明细加载失败，请稍后重试",
  "devUpdates.thisWarehouseReceiptHasBeenSavedDeleteIt":
    "该入仓记录已保存，确认删除吗？",
  "devUpdates.enterDatesAndReceiptNumbersForAllWarehouseReceipts":
    "请先填写所有入仓记录的日期和入仓号",
  "devUpdates.imagesOrVideosAreUploadingWaitBeforeSwitchingProducts":
    "图片或视频上传中，请稍后再切换商品",
  "devUpdates.productNumberIsMissing": "缺少商品编号",
  "devUpdates.selectAtLeastOneProduct": "请至少选择一个商品",
  "devUpdates.imagesOrVideosAreUploadingWaitBeforeConfirmingInspection":
    "图片或视频上传中，请稍后确认验货",
  "devUpdates.yourRoleCannotSaveInspectionImagesOrTerms":
    "当前角色不能保存验货图片和条款",
  "devUpdates.eachWarehouseReceiptQuantityMustBeGreaterThanZero":
    "每项入仓实际数量都必须大于0",
  "devUpdates.inspectionQuantityIsRequired": "验货数量不能为空",
  "devUpdates.currentProductSaved": "当前商品保存成功",
  "devUpdates.theCurrentStatusDoesNotAllowInspectionConfirmation":
    "当前状态不允许确认验货",
  "devUpdates.enterApprovalNotes": "请填写审批备注",
  "devUpdates.inspectionConfirmed": "确认验货成功！",
  "devUpdates.theCurrentStatusDoesNotAllowRejection": "当前状态不允许驳回",
  "devUpdates.rejectionReasonRequired": "请填写驳回原因",
  "devUpdates.rejectedSuccessfully": "驳回成功！",
  "devUpdates.warning": "警告",
  "devUpdates.selectProductSpecificationsFirst": "请先勾选商品规格",
  "devUpdates.insufficientStockForTheSelectedSpecifications":
    "所选商品规格库存不足",
  "devUpdates.withdrawingStopsReviewAndSavesAPrivateDraftYouCanThenEditOrDeleteIt":
    "撤回后，该词条将停止审核并保存为仅你可见的草稿。之后可以继续编辑或删除草稿。",
  "devUpdates.confirmWithdrawal": "确认撤回投稿",
  "devUpdates.submissionWithdrawnAndSavedAsADraftOutsideTheReviewQueue":
    "投稿已撤回并保存为草稿，不再进入审核队列",
  "devUpdates.deletingRemovesThisDraftFromMyPublicationsAndCannotBeUndone":
    "删除后，该草稿将从“我的发布”中移除，且无法由你恢复。",
  "devUpdates.confirmDraftDeletion": "确认删除草稿",
  "devUpdates.draftDeleted": "草稿已删除",
  "devUpdates.noReadableDatasheetPdfIsLinkedToThisSource":
    "该来源暂未关联可打开的规格书 PDF",
  "devUpdates.logInToViewTheFullDatasheet": "请先登录后再查看完整规格书",
  "devUpdates.failedToLoadKnowledgeBaseDetailsTryAgainLater":
    "知识库详情加载失败，请稍后重试",
  "devUpdates.entryNameCopied": "词条名称已复制",
  "devUpdates.failedToLoadVersionHistoryTryAgainLater":
    "历史版本加载失败，请稍后重试",
  "devUpdates.noPublishedHistoricalVersions": "暂无已发布的历史版本",
  "devUpdates.thisAccountCannotReviewWikiEntries": "当前账号没有百科审核权限",
  "devUpdates.aManualReviewMustApproveReturnForRevisionOrReject":
    "真实人工复核记录只能选择审核通过、退回修改或审核不通过",
  "devUpdates.logInBeforeSaving": "请先登录后再收藏",
  "devUpdates.noDatasheetsAvailableToDownload": "暂无可下载的规格书",
  "devUpdates.protectedDownloadIsUnavailableDownloadFromTheKnowledgeBaseProductPage":
    "该规格书暂不支持受保护下载，请从知识库产品页下载",
  "devUpdates.logInToDownloadTheDatasheet": "请先登录后再下载规格书",
  "devUpdates.cannotLoadDownloadCreditsTryAgainLater":
    "暂时无法获取下载积分，请稍后重试",
  "devUpdates.confirmDatasheetDownload": "确认下载规格书",
  "devUpdates.datasheetDownloadsAreUnavailableTryAgainLater":
    "规格书下载服务暂不可用，请稍后重试",
  "devUpdates.downloadingDatasheetUnlimitedFreeDownloadsForAdministrators":
    "规格书下载中（管理员无限次免费下载）",
  "devUpdates.downloadingAPurchasedDatasheetNoCreditsDeducted":
    "规格书下载中（已购规格书，本次不扣积分）",
  "devUpdates.dataExportStarted": "数据导出已开始",
  "devUpdates.failedToLoadWikiProductsTryAgainLater":
    "百科产品加载失败，请稍后重试",
  "devUpdates.failedToLoadMoreProductsTryAgainLater":
    "加载更多产品失败，请稍后重试",
  "devUpdates.datasheetsMustBePdfFiles": "规格书仅支持 PDF 格式",
  "devUpdates.datasheetsMustNotExceed50Mb": "规格书不能超过 50MB",
  "devUpdates.eachWikiEntryAllowsOneDatasheetRemoveTheSelectedFileFirst":
    "每个百科词条只能上传一份规格书，请先移除已选文件",
  "devUpdates.failedToLoadScheduledPublication": "加载计划发布内容失败",
  "devUpdates.immediatePublicationFailed": "立即发布失败",
  "devUpdates.cancelScheduledPublication": "取消计划发布",
  "devUpdates.scheduledPublicationCancelledTheEntryWasSavedAsADraft":
    "计划发布已取消，词条已保存为草稿",
  "devUpdates.failedToCancelScheduledPublication": "取消计划发布失败",
  "devUpdates.thisFileFormatIsNotSupported": "暂不支持该文件格式",
  "devUpdates.noPublishableWikiContentRecognized": "没有识别到可发布的百科内容",
  "devUpdates.fileParsingFailedCheckTheFileContents":
    "文件解析失败，请检查文件内容",
  "devUpdates.requiredFieldsMissing": "请填写必填项",
  "devUpdates.selectAFuturePublicationTime": "请选择晚于当前时间的计划发布时间",
  "devUpdates.datasheetPromotionalContentWarning":
    "上传的 PDF 疑似包含广告或导流内容，请更换为合规的官方规格书",
  "devUpdates.thePdfIsUnrelatedToChipSpecificationsSelectTheDatasheetForThisPart":
    "上传的 PDF 与芯片规格资料无关，请重新选择对应型号的规格书",
  "devUpdates.datasheetTextExtractionManualReviewHint":
    "该 PDF 暂时无法提取原文，提交后将转人工复核，不能自动发布",
  "devUpdates.addAtLeastOneWikiEntry": "请至少填写一条百科内容",
  "devUpdates.batchSubmissionStoppedOnFailure":
    "本批存在提交失败的内容，已停止后续提交并保留未完成数据，请检查后重试",
  "devUpdates.answerDeleted": "回答已删除",
  "devUpdates.commentDeleted": "评论已删除",
  "devUpdates.commentPublished": "评论已发布",
  "devUpdates.newCompanyProfile": "新建公司资料",
  "devUpdates.enterCompanyDetailsCertificatesAndLinkedAccountsForPurchaseOrders":
    "录入公司基础资料、证照与绑定信息，用于采购订单主体选择",
  "devUpdates.mainlandChinaCompany": "大陆企业",
  "devUpdates.hongKongMacaoOrTaiwanCompany": "港澳台企业",
  "devUpdates.enterTextOrPasteAnImage": "请输入文本或粘贴图片内容",
  "devUpdates.supplierShortName": "供应商简称",
  "devUpdates.enterTheSupplierShortName": "请填写供应商简称",
  "devUpdates.enterTheCompanyNameInEnglish": "请填写公司名称(英)",
  "devUpdates.companyCode": "公司编码",
  "devUpdates.enterTheCompanyCode": "请填写公司编码",
  "devUpdates.legalRepresentative": "公司法人",
  "devUpdates.enterTheLegalRepresentative": "请填写公司法人",
  "devUpdates.searchLinkedCompanies": "搜索绑定公司",
  "devUpdates.noMatchingCompanies": "未找到匹配的公司",
  "devUpdates.enterTheCompanyAddress": "请填写公司地址",
  "devUpdates.enterTheCompanyPhoneNumber": "请填写公司电话",
  "devUpdates.linkedBankAccounts": "绑定银行",
  "devUpdates.noBankAccountsAvailableToLink": "无可绑定的银行",
  "devUpdates.uploadAFrameworkAgreement": "上传框架协议",
  "devUpdates.uploadASupplierQuestionnaire": "上传供应商调查表",
  "devUpdates.uploadAnAuditReport": "上传审计报告",
  "devUpdates.submitCompanyProfile": "提交公司资料",
  "devUpdates.taxIdAndMainlandChinaBankDetails": "公司税号及大陆银行信息",
  "devUpdates.registrationNumberAndOverseasBankDetails": "登记号及境外银行信息",
  "devUpdates.imagePreviewForRecognition": "待识别图片预览",
  "devUpdates.removeImageForRecognition": "移除待识别图片",
  "devUpdates.companyAttributes": "公司属性",
  "devUpdates.parentCompany": "主公司",
  "devUpdates.searchCompaniesToLink": "搜索需要绑定的公司",
  "devUpdates.multipleSelectionsAllowed": "可多选",
  "devUpdates.selected": "· 已选",
  "devUpdates.items": "项",
  "devUpdates.noLinkableBankAccounts": "暂无可绑定银行",
  "devUpdates.selectCompaniesToLink": "选择绑定公司",
  "devUpdates.searchCompanyNames": "搜索公司名称",
  "devUpdates.enterCompanyDetailsCertificatesAndLinkedAccountsToManageSuppliers":
    "录入公司基础资料、证照与绑定信息，用于供应商资料管理",
  "devUpdates.smartRecognitionPdfPngAndJpg":
    "智能识别（支持pdf,png,jpg图片格式）",
  "devUpdates.enterTextOrPasteCompanyDetails": "请输入文本或粘贴公司资料内容",
  "devUpdates.companyLocation": "公司所在地",
  "devUpdates.selectCountryProvinceCityAndDistrict": "请选择国家/省/市/区",
  "devUpdates.reportYear": "报告年份",
  "devUpdates.selectAYear": "请选择年份",
  "devUpdates.searchPastConversations": "搜索历史会话",
  "devUpdates.search": "搜索...",
  "devUpdates.newConversation": "新建对话",
  "devUpdates.noMatchingConversations": "未找到相关会话",
  "devUpdates.backToXsouAi": "回到先搜AI",
  "devUpdates.goToProfile": "前往个人主页",
  "devUpdates.scanComingSoon": "扫一扫（开发中）",
  "devUpdates.comingSoon": "开发中",
  "devUpdates.remindersComingSoon": "提醒（开发中）",
  "devUpdates.settingsComingSoon": "设置（开发中）",
  "devUpdates.conversationActions": "会话操作",
  "devUpdates.renameConversation": "编辑对话名称",
  "devUpdates.removeFromConversations": "从对话列表删除",
  "devUpdates.conversationName": "对话名称",
  "devUpdates.findInConversation": "查找聊天内容",
  "devUpdates.clearSearch": "清空搜索内容",
  "devUpdates.cancelSearch": "取消查找",
  "devUpdates.enterAKeywordToSearchThisConversation": "输入关键词查找当前对话",
  "devUpdates.noMatchingContentInThisConversation": "当前对话中未找到相关内容",
  "devUpdates.pastConversations": "历史会话",
  "devUpdates.aiGeneratedContent": "内容由 AI 生成",
  "devUpdates.voiceCallComingSoon": "语音通话（开发中）",
  "devUpdates.speakerComingSoon": "扬声器（开发中）",
  "devUpdates.currentConversationActions": "当前会话操作",
  "devUpdates.createAConversation": "创建新对话",
  "devUpdates.searchKeywordsAndReferences": "搜索关键词和参考资料",
  "devUpdates.responseActions": "回复操作",
  "devUpdates.copyResponse": "复制回复",
  "devUpdates.readAloudComingSoon": "朗读（开发中）",
  "devUpdates.readResponseAloudComingSoon": "朗读回复（开发中）",
  "devUpdates.saveComingSoon": "收藏（开发中）",
  "devUpdates.saveResponseComingSoon": "收藏回复（开发中）",
  "devUpdates.shareComingSoon": "分享（开发中）",
  "devUpdates.shareResponseComingSoon": "分享回复（开发中）",
  "devUpdates.regenerateComingSoon": "重新生成（开发中）",
  "devUpdates.regenerateResponseComingSoon": "重新生成回复（开发中）",
  "devUpdates.generating": "正在生成",
  "devUpdates.goToLatestMessage": "回到最新消息",
  "devUpdates.takeAPhotoOrUploadAFileComingSoon": "拍照或上传附件（开发中）",
  "devUpdates.sendAMessage": "发消息...",
  "devUpdates.voiceInputComingSoon": "语音输入（开发中）",
  "devUpdates.addComingSoon": "添加（开发中）",
  "devUpdates.cancelUpload": "取消上传",
  "devUpdates.chipPhotoToUpload": "待上传的芯片照片",
  "devUpdates.takeAPhoto": "拍照",
  "devUpdates.retakePhoto": "重新拍照",
  "devUpdates.confirmUpload": "确认上传",
  "devUpdates.references": "参考链接",
  "devUpdates.onlySourcesCitedInThisResponseAreShown":
    "仅显示本次答案实际引用的资料。",
  "devUpdates.mainNavigation": "主要导航",
  "devUpdates.bidding": "竞价",
  "devUpdates.changeLanguage": "切换语言",
  "devUpdates.celebratingTheFoundingOfThePeoplesRepublicOfChina":
    "庆祝中华人民共和国成立",
  "devUpdates.anniversary": "周年",
  "devUpdates.quickPartNumberSearch": "快捷型号搜索",
  "devUpdates.quickSearch": "快捷搜索",
  "devUpdates.copyright20172026XsouTechnology":
    "Copyright © 2017-2026 先搜科技 (",
  "devUpdates.closeHolidayGreeting": "关闭节日祝福",
  "devUpdates.xsouHolidayLogo": "XSOU节日标志",
  "devUpdates.thisProductIsAlreadyLinked": "该商品已绑定，请勿重复绑定",
  "devUpdates.logInBeforeLinkingTheProduct": "请先登录，再绑定商品",
  "devUpdates.confirmLinking": "确认绑定",
  "devUpdates.contractApprovalSteps": "发起合同审批步骤",
  "devUpdates.copySellerInvitationLink": "复制邀请货主链接",
  "devUpdates.partNumber": "商品料号：",
  "devUpdates.productId": "商品ID：",
  "devUpdates.orderAttachments": "订单附件",
  "devUpdates.files": "个",
  "devUpdates.relatedContent": "关联内容",
  "devUpdates.sellerReviewer": "货主审核人",
  "devUpdates.noSellerReviewers": "暂无货主审核人",
  "devUpdates.addReviewer": "添加审核人",
  "devUpdates.noReviewersAdded": "暂未添加审核人",
  "devUpdates.downloadContractTemplate": "下载合同模版",
  "devUpdates.generatePoPurchaseOrder": "生成PO采购订单",
  "devUpdates.generatePiProFormaInvoice": "生成PI形式发票",
  "devUpdates.generatePlPackingList": "生成PL装箱单",
  "devUpdates.generateInvContract": "生成INV合同",
  "devUpdates.generateDeliveryNote": "生成送货单",
  "devUpdates.generateSalesContract": "生成销售合同",
  "devUpdates.supplierUploadsASingleStampedContract":
    "由供应商上传单章合同文件",
  "devUpdates.addRelatedContent": "添加关联内容",
  "devUpdates.noRelatedContentAdded": "暂未关联内容",
  "devUpdates.viewDocuments": "查看资料",
  "devUpdates.documents": "资料",
  "devUpdates.previous": "上一步",
  "devUpdates.next": "下一步",
  "devUpdates.noMatchingCcRecipients": "未找到匹配的抄送人",
  "devUpdates.documentDetails": "资料详情",
  "devUpdates.closeDocumentDetails": "关闭资料详情",
  "devUpdates.salesOrderProducts": "销售订单商品",
  "devUpdates.thisPageIsCurrentlyUnavailable": "暂时无法查看该页面",
  "devUpdates.loadingPaymentInformation": "正在加载付款信息",
  "devUpdates.paymentNotes": "付款备注",
  "devUpdates.paymentRequestNotes": "付款申请备注",
  "devUpdates.paymentApprovalWorkflow": "付款审批流程",
  "devUpdates.backToOrder": "返回订单",
  "devUpdates.noRelatedContent": "暂无关联内容",
  "devUpdates.purchaseOrderProducts": "采购订单商品",
  "devUpdates.invReviewer": "INV审核人",
  "devUpdates.purchaseOrderSteps": "采购订单填写步骤",
  "devUpdates.switchAccount": "切换账号",
  "devUpdates.selectProductProvider": "选择商品提供人",
  "devUpdates.addPurchaseProduct": "添加采购商品",
  "devUpdates.enterTheProductBrand": "请填写产品品牌名称",
  "devUpdates.enterThePartNumber": "请填写产品料号",
  "devUpdates.enterTheUnitPrice": "请填写产品单价",
  "devUpdates.quantityUnit": "产品数量/单位",
  "devUpdates.enterThePurchaseQuantity": "请填写采购数量",
  "devUpdates.productUnit": "产品单位",
  "devUpdates.enterTheProductTotal": "请填写产品总价",
  "devUpdates.enterTheDeliveryRegion": "请填写交货地区",
  "devUpdates.enterTheDateCodeDc": "请输入批次(DC)",
  "devUpdates.productConditionMultipleSelections": "货物情况（多选）",
  "devUpdates.noPurchaseProductsAddProductsInPurchaseSettings":
    "暂无采购商品，请在采购设置中添加",
  "devUpdates.theContractNumberIsGeneratedAfterSelectingTheSellerCompany":
    "合同编号在选择卖方公司后自动生成",
  "devUpdates.duplicatesAllowed": "允许重复",
  "devUpdates.selectADeliveryDate": "请选择交货日期",
  "devUpdates.asNegotiated": "按照商定",
  "devUpdates.selectAPurchaseNegotiator": "请选择采购谈判人",
  "devUpdates.estimatedCommission": "预估佣金",
  "devUpdates.enterTheEstimatedCommission": "请填写预估佣金",
  "devUpdates.enterTheAfterSalesTerms": "请填写售后条款",
  "devUpdates.enterOrderNotes": "请填写订单备注",
  "devUpdates.selectOrEnterTheCompanyName": "请选择或填写公司名称",
  "devUpdates.create": "新建",
  "devUpdates.enterTheFullAddress": "请填写详细地址",
  "devUpdates.enterTheBankNameInEnglish": "请填写银行英文名称",
  "devUpdates.enterTheBankNameInChinese": "请填写银行中文名称",
  "devUpdates.enterTheAccountBank": "请填写开户银行",
  "devUpdates.enterTheBankAccountNumber": "请填写银行账号",
  "devUpdates.enterTheSwiftCode": "请填写 Swift Code",
  "devUpdates.enterTheBankCode": "请填写 Bank Code",
  "devUpdates.bankAddressChinese": "银中地址",
  "devUpdates.enterTheBankAddressInChinese": "请填写银行中文地址",
  "devUpdates.bankAddressEnglish": "银英地址",
  "devUpdates.enterTheBankAddressInEnglish": "请填写银行英文地址",
  "devUpdates.enterTheShippingAddress": "请填写收货地址",
  "devUpdates.orderSubmission": "订单提交操作",
  "devUpdates.purchaseQuote": "采购报价",
  "devUpdates.generateOrder": "生成订单",
  "devUpdates.selectDeliveryDate": "选择交货日期",
  "devUpdates.selectPurchaseNegotiator": "选择采购谈判人",
  "devUpdates.searchPurchaseNegotiators": "搜索采购谈判人",
  "devUpdates.noMatchingNegotiators": "未找到匹配的谈判人",
  "devUpdates.enterANameToSearchPurchaseNegotiators": "输入姓名搜索采购谈判人",
  "devUpdates.companies": "公司列表",
  "devUpdates.total": "共",
  "devUpdates.companyCountUnit": "家",
  "devUpdates.noCompanyProfiles": "暂无公司资料",
  "devUpdates.loadingOrderInformation": "正在加载订单信息",
  "devUpdates.requestPaymentApproval": "发起付款审批",
  "devUpdates.salesOrderSteps": "销售订单填写步骤",
  "devUpdates.selectTheProductBrand": "请选择产品品牌",
  "devUpdates.enterTheSalesQuantity": "请填写销售数量",
  "devUpdates.selectTheDeliveryRegion": "请选择交货地区",
  "devUpdates.selectASalesNegotiator": "请选择销售谈判人",
  "devUpdates.clearSalesNegotiator": "清除销售谈判人",
  "devUpdates.selectACompany": "请选择公司名称",
  "devUpdates.enterThePrimaryContact": "请填写主联系人",
  "devUpdates.change": "更换",
  "devUpdates.clearSellerContact": "清除卖方联系人",
  "devUpdates.clearSellerPhoneNumber": "清除卖方联系电话",
  "devUpdates.enterTheSellerTaxId": "请填写卖方公司税号",
  "devUpdates.selectABank": "请选择银行",
  "devUpdates.enterTheBankBranch": "请填写开户支行",
  "devUpdates.enterTheBankRoutingNumber": "请填写联行号",
  "devUpdates.clearBuyerContact": "清除买方联系人",
  "devUpdates.clearBuyerPhoneNumber": "清除买方联系电话",
  "devUpdates.enterTheBuyerTaxId": "请填写买方公司税号",
  "devUpdates.selectAShippingAddress": "请选择收货地址",
  "devUpdates.salesOrderSubmission": "销售订单提交操作",
  "devUpdates.mergeOrderSelection": "选择合并订单",
  "devUpdates.selectSalesNegotiator": "选择销售谈判人",
  "devUpdates.searchNegotiators": "搜索谈判人",
  "devUpdates.negotiators": "谈判人列表",
  "devUpdates.people": "人",
  "devUpdates.noNegotiators": "暂无谈判人数据",
  "devUpdates.confirmOrderInformation": "确认订单信息",
  "devUpdates.orderSummary": "订单汇总",
  "devUpdates.contractAndDelivery": "合同与交付",
  "devUpdates.backToEdit": "返回修改",
  "devUpdates.purchaseDetails": "订购详情",
  "devUpdates.tradeInformation": "交易信息",
  "devUpdates.purchaseQuantity": "订购数量",
  "devUpdates.buyerWechat": "买家微信",
  "devUpdates.orderTime": "订购时间",
  "devUpdates.productDocuments": "产品资料",
  "devUpdates.sellerWechat": "货主微信",
  "devUpdates.negotiatorPhoneNumber": "谈判人手机号",
  "devUpdates.generateContract": "生成合同",
  "devUpdates.generateTradeContract": "生成交易合同",
  "devUpdates.tradePrice": "成交价",
  "devUpdates.tradeQuantity": "成交数量",
  "devUpdates.buyerTransactionFee": "买家成单费用",
  "devUpdates.sellerTransactionFee": "货主成单费用",
  "devUpdates.productAmount": "商品金额",
  "devUpdates.amountDue": "应付金额",
  "devUpdates.readOnly": "只读",
  "devUpdates.paymentAmount": "本次付款金额",
  "devUpdates.submittingPaysTheFullAmountDueInOnePayment":
    "提交后将按订单应付总额一次性完成付款",
  "devUpdates.completeOrder": "完结订单",
  "devUpdates.deleteInstallment": "删除该期",
  "devUpdates.installmentName": "分期名称",
  "devUpdates.enterTheInstallmentName": "请输入分期名称",
  "devUpdates.requestedInstallmentAmount": "本期申请支付金额",
  "devUpdates.enterThePaymentAmount": "请输入付款金额",
  "devUpdates.percentage": "占比",
  "devUpdates.paymentDate": "付款时间",
  "devUpdates.selectAPaymentDate": "请选择付款时间",
  "devUpdates.selectTheOrderingCompany": "请选择下单公司",
  "devUpdates.paymentBank": "付款银行",
  "devUpdates.selectAPaymentBank": "请选择付款银行",
  "devUpdates.addInstallment": "添加分期",
  "devUpdates.onlyOneInstallmentCanBeAddedAtATime": "每次仅可新增 1 期",
  "devUpdates.orderTotal": "订单总额",
  "devUpdates.orderTotalPaid": "订单总额已支付",
  "devUpdates.receivingAccount": "收款账户",
  "devUpdates.syncAttachments": "同步附件",
  "devUpdates.paymentMethodAttachments": "付款方式附件",
  "devUpdates.paymentMethodNotes": "付款方式备注",
  "devUpdates.enterPaymentMethodNotes": "请填写付款方式备注",
  "devUpdates.orderNumber": "订单号：",
  "devUpdates.installmentAmountDue": "本期应付金额",
  "devUpdates.approve": "通过审核",
  "devUpdates.submitPaymentReceipt": "提交付款凭证",
  "devUpdates.confirmPaymentReceipt": "确认付款凭证",
  "devUpdates.selectPaymentDate": "选择付款日期",
  "devUpdates.selectOrderingCompany": "选择下单公司",
  "devUpdates.enterACompanyNameToSearch": "输入公司名称进行模糊查询",
  "devUpdates.searching": "查询中...",
  "devUpdates.matchingCompanyListEmpty": "暂无匹配公司",
  "devUpdates.selectPaymentBank": "选择付款银行",
  "devUpdates.noPaymentBanks": "暂无付款银行",
  "devUpdates.rejectPaymentMethod": "驳回付款方式",
  "devUpdates.poster": "海报",
  "devUpdates.passwordlessLogin": "免密登录",
  "devUpdates.wechatQrCode": "微信二维码",
  "devUpdates.scanWithWechatToLogInOrSignUp": "打开微信扫一扫，快速登录/注册",
  "devUpdates.byLoggingInOrSigningUpYouAgreeTo": "登录/注册即代表同意",
  "devUpdates.and": "与",
  "devUpdates.orderAmount": "订单金额：",
  "devUpdates.created": "创建时间：",
  "devUpdates.tradeDetailsAreIncomplete": "交易详情内容待补充完整",
  "devUpdates.type": "类型：",
  "devUpdates.noContent": "暂无内容",
  "devUpdates.remaining": "余",
  "devUpdates.inspectionWorkflow": "验货流程",
  "devUpdates.businessInspection": "商务验货",
  "devUpdates.supervisorConfirmation": "监督确认",
  "devUpdates.inspectionCompleted": "验货完成",
  "devUpdates.productDirectory": "商品目录",
  "devUpdates.products": "个商品",
  "devUpdates.batchActions": "批量操作",
  "devUpdates.rejectionReason": "驳回原因：",
  "devUpdates.failedToLoadInspectionInformation": "验货信息加载失败",
  "devUpdates.quantityNotReceived": "未入仓数量",
  "devUpdates.quantityReceived": "已入仓数量",
  "devUpdates.warehouseReceiptDetails": "入仓明细",
  "devUpdates.addWarehouseReceipt": "添加入仓",
  "devUpdates.syncOtherProducts": "同步其他商品",
  "devUpdates.warehouseReceiptDate": "入仓日期",
  "devUpdates.warehouseReceiptNumber": "入仓号",
  "devUpdates.enterTheWarehouseReceiptNumber": "请输入入仓号",
  "devUpdates.actualQuantity": "实际数量",
  "devUpdates.deleteWarehouseReceipt": "删除入仓记录",
  "devUpdates.inspectionDocuments": "验货资料",
  "devUpdates.uploading": "上传中",
  "devUpdates.unopenedProductDetails": "未拆封细节",
  "devUpdates.unopenedPackaging": "未拆封包装",
  "devUpdates.photos": "图 ·",
  "devUpdates.openedProductDetails": "已拆封细节",
  "devUpdates.additionalInspectionTerms": "补充验货条款",
  "devUpdates.enterAdditionalInspectionTerms": "请输入补充验货条款",
  "devUpdates.approvalNotes": "审批备注",
  "devUpdates.loadingInspectionInformation": "正在加载验货信息",
  "devUpdates.enterRejectionReason": "填写驳回原因",
  "devUpdates.enterTheReason": "请输入具体原因",
  "devUpdates.confirmRejection": "确认驳回",
  "devUpdates.enterTheSupplierName": "请输入供应商名称",
  "devUpdates.add": "新增",
  "devUpdates.filterByLinkedBank": "绑定银行筛选",
  "devUpdates.allBanks": "全部银行",
  "devUpdates.suppliers": "供应商列表",
  "devUpdates.resetFilters": "重置筛选",
  "devUpdates.parentCompanyName": "主公司名称",
  "devUpdates.contactInformation": "联系信息",
  "devUpdates.supplierBankDetails": "供应商银行信息",
  "devUpdates.accounts": "个账户",
  "devUpdates.subsidiaryName": "子公司名称",
  "devUpdates.businessRegistrationCertificate": "商业登记证",
  "devUpdates.auditReport": "审计报告",
  "devUpdates.purchaseAgreement": "采购协议",
  "devUpdates.questionnaire": "调查表",
  "devUpdates.profileCreatedLabel": "建档日期：",
  "devUpdates.expires": "到期：",
  "devUpdates.noSuppliers": "暂无供应商数据",
  "devUpdates.addSupplier": "新增供应商",
  "devUpdates.supplierActions": "供应商操作",
  "devUpdates.addBank": "新建银行",
  "devUpdates.addAddress": "新增地址",
  "devUpdates.changeAddress": "更换地址",
  "devUpdates.deleteSupplier": "删除供应商",
  "devUpdates.supplierDetails": "供应商详情",
  "devUpdates.documentFiles": "资料文件",
  "devUpdates.contactDetails": "联系人信息",
  "devUpdates.bankName": "银行名称",
  "devUpdates.noSupplierBankDetails": "暂无供应商银行信息",
  "devUpdates.noLinkedBanks": "暂未绑定银行",
  "devUpdates.subsidiaryInformation": "子公司信息",
  "devUpdates.tradeStatus": "交易状态",
  "devUpdates.noSubsidiaries": "暂无子公司信息",
  "devUpdates.selectOurBankAccountsAvailableToThisSupplier":
    "选择该供应商可使用的我方银行账户",
  "devUpdates.bankAccountLinkOptionsEmpty": "暂无可绑定的银行",
  "devUpdates.saveLinkedAccounts": "保存绑定",
  "devUpdates.selectBank": "选择银行",
  "devUpdates.noBankDetailsForThisCompany": "当前公司暂无银行资料",
  "devUpdates.publishBidding": "竞标发布",
  "devUpdates.backToBidding": "返回竞标",
  "devUpdates.batchUpload": "批量上传",
  "devUpdates.privacyProtection": "隐私保护",
  "devUpdates.createCompanyProfileAction": "+ 新建公司资料",
  "devUpdates.enterTheReceivingAccountNumber": "请填写收款账号",
  "devUpdates.publisher": "信息发布者",
  "devUpdates.selectABusinessTeamMember": "请选择业务组人员",
  "devUpdates.selectAWeekIn2026": "选择26年的第几周",
  "devUpdates.selectStatus": "选择状态",
  "devUpdates.productLocation": "所货地",
  "devUpdates.selectRegion": "选择地区",
  "devUpdates.factorySealed": "原封",
  "devUpdates.other": "其它",
  "devUpdates.enterNotes": "请填写备注信息",
  "devUpdates.details": "详细信息",
  "devUpdates.productIdLink": "商品ID/链接",
  "devUpdates.enterTheProductIdOrLink": "请填写商品ID或链接",
  "devUpdates.specificationDatasheet": "规格书 / 数据手册",
  "devUpdates.uploadExcelFilesInBulk": "批量上传Excel文件",
  "devUpdates.dropAnExcelFileHereOr": "将Excel文件拖到此处，或",
  "devUpdates.supportsXlsxAndXls": "支持 .xlsx, .xls 格式",
  "devUpdates.parsed": "已解析",
  "devUpdates.records": "条数据",
  "devUpdates.remainingPrefix": "还有",
  "devUpdates.moreRecords": "条数据...",
  "devUpdates.bidLot": "标单",
  "devUpdates.code": "编码",
  "devUpdates.enterTheCode": "请填写编码",
  "devUpdates.selectProductCategory": "选择产品分类",
  "devUpdates.enterCapacity": "请填写容量",
  "devUpdates.selectPackage": "选择封装",
  "devUpdates.selectTechnology": "选择技术",
  "devUpdates.enterStockQuantity": "请填写库存",
  "devUpdates.packagingSelection": "选择包装",
  "devUpdates.duplicateProductBindingNotAllowed":
    "该商品已绑定，请勿重复绑定商品",
  "devUpdates.pleaseFirstPrefix": "请先",
  "devUpdates.beforeLinkingTheProduct": "，再绑定商品",
  "devUpdates.published": "发布时间：",
  "devUpdates.publishSupplyDemand": "供需发布",
  "devUpdates.registerABrand": "品牌入驻",
  "devUpdates.view": "视图：",
  "devUpdates.brandCategory": "品牌分类：",
  "devUpdates.region": "地区：",
  "devUpdates.sort": "排序：",
  "devUpdates.productCount": "产品数",
  "devUpdates.popularity": "热度",
  "devUpdates.founded": "成立年份",
  "devUpdates.companyCount": "企业数",
  "devUpdates.orders": "订单数",
  "devUpdates.viewProducts": "查看产品",
  "devUpdates.brandName": "品牌名",
  "devUpdates.brandIntroduction": "品牌简介",
  "devUpdates.active": "已生效",
  "devUpdates.noMatchingBrands": "暂无相关品牌信息",
  "devUpdates.productDetails": "商品明细",
  "devUpdates.addDifferentBrandsPartNumbersQuantitiesAndUnitPrices":
    "同一产品可添加不同品牌、料号、数量和单价",
  "devUpdates.addProduct": "添加商品",
  "devUpdates.unitPrice": "单价：",
  "devUpdates.noOrderAttachments": "暂无订单附件",
  "devUpdates.contractApprovalInformation": "发起合同审批信息",
  "devUpdates.contractApprovalOverview": "合同审批信息",
  "devUpdates.completePaymentReviewerAndContractFileInformation":
    "补充付款、审核人与合同文件信息",
  "devUpdates.approvalAndRelatedContent": "审批与关联",
  "devUpdates.removeReviewer": "移除审核人",
  "devUpdates.contractFiles": "合同文件",
  "devUpdates.downloadContractTemplateAction": "下载合同模板",
  "devUpdates.generatePoPurchaseContract": "生成PO采购合同",
  "devUpdates.moreSalesOrderInformation": "更多销售订单信息",
  "devUpdates.buyerType": "买方类型",
  "devUpdates.recipientPhoneNumber": "收货人电话",
  "devUpdates.totalPrice": "总价",
  "devUpdates.moreDocuments": "更多资料",
  "devUpdates.viewSpecification": "点击查看规格书",
  "devUpdates.enter": "输入",
  "devUpdates.aNameToSearchAndAdd": "姓名搜索并添加",
  "devUpdates.noSearchResults": "无搜索结果",
  "devUpdates.buyerAndSellerInformation": "买卖双方资料",
  "devUpdates.checkTradingPartiesBankDetailsAndPaymentAttachments":
    "核对交易主体、银行资料及付款相关附件",
  "devUpdates.paymentDocuments": "付款文件",
  "devUpdates.viewTradeContractsAndUploadDocumentsRequiredForPayment":
    "集中查看交易合同，并上传付款流程所需文件",
  "devUpdates.tradeContractPo": "交易合同（PO）",
  "devUpdates.productAndPurchaseInformation": "商品与采购信息",
  "devUpdates.confirmTheProviderNegotiatorAndPurchaseProducts":
    "确认商品提供人、谈判人和本次采购商品",
  "devUpdates.selectAProductProvider": "请选择商品提供人",
  "devUpdates.completeProductTradeFieldsArrangedInFourColumns":
    "完整展示商品交易字段，四列排布提升填写效率",
  "devUpdates.confirmContractNumberDeliveryDateOrderTypeAndNotes":
    "确认合同编号、交货日期、订单类型与补充说明",
  "devUpdates.enterTheContractNumber": "请填写合同编号",
  "devUpdates.completeSellerCompanyContactAddressAndBankDetails":
    "完整展示卖方公司、联系人、地址与银行信息",
  "devUpdates.showHiddenInformation": "展开隐藏信息",
  "devUpdates.sellerCompanyTaxIdRequired": "请填写卖公司税号",
  "devUpdates.enterTheBankName": "请填写银行名称",
  "devUpdates.swiftCodeRequired": "请填写Swift Code",
  "devUpdates.bankCodeRequired": "请填写Bank Code",
  "devUpdates.bankEnglishAddressRequired": "请填写银英地址",
  "devUpdates.completeBuyerCompanyContactAndShippingDetails":
    "完整展示买方公司、联系人与收货信息",
  "devUpdates.buyerCompanyTaxIdRequired": "请填写买公司税号",
  "devUpdates.addNotesForThisPurchaseOrderRequest": "补充本次采购订单申请备注",
  "devUpdates.confirmInformationRequestAPurchaseQuoteThenGenerateTheOrder":
    "确认信息后执行采购报价，报价完成后生成订单",
  "devUpdates.piProFormaInvoice": "PI（形式发票）",
  "devUpdates.ciCommercialInvoice": "CI（正式发票）",
  "devUpdates.quantity": "数量(",
  "devUpdates.selectOrdersForTheSameBuyerToMergeIntoASalesOrder":
    "勾选同一买方下的订单，合并后统一生成销售订单",
  "devUpdates.editSalesProductsPricesQuantitiesDeliveryRegionsAndConditions":
    "维护销售商品、价格、数量、交货地区与货物情况",
  "devUpdates.enterTheUnit": "请填写单位",
  "devUpdates.orderDocuments": "订单资料",
  "devUpdates.currentOrder": "当前订单：",
  "devUpdates.uploaded": "已上传",
  "devUpdates.confirmContractNumberDeliveryDateOrderTypeNegotiatorAfterSalesTermsAndPaymentMethod":
    "确认合同编号、交货日期、订单类型、谈判人、售后条款与付款方式",
  "devUpdates.addNotesForThisSalesOrderRequest": "补充本次销售订单申请备注",
  "devUpdates.thePurchasingTeamCanGenerateASalesOrderAfterRequestingAQuote":
    "采购商务点击采购报价后即可生成销售订单",
  "devUpdates.orderContractInformation": "订单 / 合同信息",
  "devUpdates.tradingParties": "交易双方",
  "devUpdates.showTradingParties": "展开交易双方",
  "devUpdates.payInFull": "全额支付",
  "devUpdates.payInInstallments": "分批支付",
  "devUpdates.completeOrderAfterFullPayment": "付完完结订单",
  "devUpdates.enterTheOrderingCompanyToSearch": "请输入下单公司查询",
  "devUpdates.reviewNumber": "审核单号",
  "devUpdates.partNumbersInThisReview": "本单料号",
  "devUpdates.totalStock": "库存合计",
  "devUpdates.partNumberCount": "料号数量",
  "devUpdates.selectedParticipants": "入选用户",
  "devUpdates.totalQuantity": "汇总数量",
  "devUpdates.settlementAmount": "结算金额",
  "devUpdates.biddingRules": "竞标规则",
  "devUpdates.publicationStatus": "发布状态",
  "devUpdates.commissionMethod": "佣金方式",
  "devUpdates.commissionRate": "佣金比例",
  "devUpdates.participationLevel": "参与等级",
  "devUpdates.publishingCompany": "发布公司",
  "devUpdates.submissionMethod": "提交方式",
  "devUpdates.publicationNotes": "发布备注",
  "devUpdates.partNumberInformation": "料号信息",
  "devUpdates.productAttributes": "商品属性",
  "devUpdates.stockAndPackaging": "库存与包装",
  "devUpdates.locationAndCondition": "所在地与货况",
  "devUpdates.loadingMoreReviewDetails": "正在加载更多审核明细",
  "devUpdates.backToTop": "回到页面顶部",
  "devUpdates.perPage": "每页",
  "devUpdates.productLocationLabel": "所货地：",
  "devUpdates.packaging": "装箱：",
  "devUpdates.stock": "库存：",
  "devUpdates.selectedParticipantsLabel": "入选用户：",
  "devUpdates.submitted": "提交：",
  "devUpdates.selectedBidders": "入选竞标用户",
  "devUpdates.confirmedMinimumPrice": "确认最低价：",
  "devUpdates.totalQuantityLabel": "汇总数量：",
  "devUpdates.feeMethod": "费用方式：",
  "devUpdates.reviewWorkflow": "审核流程",
  "devUpdates.enterReviewNotes": "请填写本次审核备注",
  "devUpdates.loadingReviewDetails": "正在加载审核明细",
  "devUpdates.reviewNotFound": "未找到该审核单",
  "devUpdates.backToReviews": "返回审核列表",
  "devUpdates.pleaseCheckAll": "请核对全部",
  "devUpdates.informationBeforeConfirmingTheReview": "信息后确认审核",
  "devUpdates.productSpecifications": "商品规格",
  "devUpdates.pagePath": "页面路径",
  "devUpdates.inspectionProgress": "验货进度",
  "devUpdates.productInformationAndWarehouseReceipts": "产品信息与入仓记录",
  "devUpdates.automaticallyTotaled": "· 自动汇总",
  "devUpdates.applyToAll": "统一",
  "devUpdates.enterTheActualQuantity": "请输入实际数量",
  "devUpdates.videos": "· 视频",
  "devUpdates.noVideos": "暂无视频",
  "devUpdates.additionalInspectionTermsRequired": "请填写补充验货条款",
  "devUpdates.enterSpecificRejectionReason": "请输入具体的驳回原因",
  "devUpdates.manageSupplierProfilesContactsBanksAndAddresses":
    "管理供应商信息及联系人、银行、地址等资料",
  "devUpdates.selectLinkedBankAccounts": "请选择绑定银行",
  "devUpdates.purchaseFrameworkAgreement": "采购框架协议",
  "devUpdates.copySupplierBankDetails": "复制供应商银行信息",
  "devUpdates.subsidiaryDetails": "子公司明细",
  "devUpdates.expiryDate": "到期日期",
  "devUpdates.ourLinkedBankAccounts": "我方绑定银行",
  "devUpdates.profileCreated": "建档日期",
  "devUpdates.supplierQuestionnaire": "供应商调查表",
  "devUpdates.createAddress": "新建地址",
  "devUpdates.bankLogo": "银行 logo",
  "devUpdates.subsidiaries": "家子公司",
  "devUpdates.bankAccounts": "个银行账户",
  "devUpdates.companyCodePlaceholder": "请输入公司编码",
  "devUpdates.legalRepresentativePlaceholder": "请输入公司法人",
  "devUpdates.companyContact": "公司联系人",
  "devUpdates.enterTheCompanyContact": "请输入公司联系人",
  "devUpdates.enterContactDetails": "请输入联系方式",
  "devUpdates.fullAddress": "详细地址",
  "devUpdates.fullAddressPlaceholder": "请输入详细地址",
  "devUpdates.bankNamePlaceholder": "请输入银行名称",
  "devUpdates.receivingAccountPlaceholder": "请输入收款账号",
  "devUpdates.bankAccountNumber": "开户行账号",
  "devUpdates.bankAccountPlaceholder": "请输入开户行账号",
  "devUpdates.bankAddress": "银行地址",
  "devUpdates.enterTheBankAddress": "请输入银行地址",
  "devUpdates.swiftCodePlaceholder": "请输入swift code",
  "devUpdates.bankCodePlaceholder": "请输入bank code",
  "devUpdates.notesPlaceholder": "请输入备注",
  "devUpdates.confirm": "确 定",
  "devUpdates.cancel": "取 消",
  "devUpdates.onlineInquiry": "在线咨询",
  "devUpdates.selectSpecifications": "选择规格",
  "devUpdates.remainingStock": "剩余库存：",
  "devUpdates.smartSearchResults": "” 的智能搜索结果",
  "devUpdates.generatedLiveByXsouAiVerifyKeyParametersAgainstTheProductDatasheet":
    "答案由先搜AI实时生成，请结合产品规格书核验关键参数。",
  "devUpdates.found": "找到",
  "devUpdates.resultsFor": "条与 “",
  "devUpdates.relatedSearchClosingQuote": "” 相关的",
  "devUpdates.results": "结果",
  "devUpdates.wikiContentIsBeingGeneratedAndWillAppearWhenReady":
    "百科内容正在生成，完成后将自动显示。",
  "devUpdates.answers": "条回答",
  "devUpdates.viewAllQA": "查看全部问答",
  "devUpdates.closeEnlargedImage": "关闭大图",
  "devUpdates.chipWikiEntryNotFound": "未找到对应芯片百科",
  "devUpdates.backToChipWiki": "返回百科列表",
  "devUpdates.generatedLiveByXsouAi": "由先搜AI实时生成",
});

// 通用业务用语
export const business = Object.freeze({
  "business.goodsCenter": "商品中心",
  "business.goodsCenterDescription": "集中查看与管理已发布商品",
  "business.publishedGoods": "发布商品",
  "business.searchAll": "全部搜索",
  "business.searchName": "名称搜索",
  "business.searchPartNumber": "料号搜索",
  "business.searchSuffix": "搜索",
  "business.nameAndPartNumber": "名称、料号",
  "business.name": "名称",
  "business.partNumber": "料号",
  "business.viewDetails": "查看详情",
  "business.editGoods": "修改商品信息",
  "business.editBuyerPhone": "修改买家号码",
  "business.editSaleRange": "修改可售范围",
  "business.inviteBuyerLink": "邀请买家链接",
  "business.noGoods": "暂无商品数据",
  "business.noMoreGoods": "没有更多商品了",
  "business.loading": "加载中...",
  "business.price": "价格",
  "business.enterPrice": "请填写价格",
  "business.cny": "人民币",
  "business.usd": "美元",
  "business.quantity": "数量",
  "business.enterQuantity": "请填写数量",
  "business.validUntil": "有效期",
  "business.selectValidUntil": "请选择有效期",
  "business.submitChanges": "提交修改",
  "business.editBuyerMobile": "修改买家手机号",
  "business.buyerMobile": "买家手机号",
  "business.addMobile": "新增手机号",
  "business.enterMobile": "请输入手机号",
  "business.set": "设置",
  "business.add": "添加",
  "business.currentBuyerMobile": "当前买家手机号",
  "business.addedMobile": "已添加手机号",
  "business.noMobile": "暂无手机号",
  "business.cancel": "取消",
  "business.confirmChanges": "确认修改",
  "business.confirmAdd": "确认添加",
  "business.purchaseBusiness": "采购商务",
  "business.purchaseNegotiator": "采购谈判人",
  "business.mobileAlreadyExists": "该手机号已存在",
  "business.onlyOneMobile": "该商品只支持添加一个手机号码",
  "business.changesSaved": "修改成功",
  "business.changesFailed": "修改失败",
  "business.copySuccess": "复制成功",
  "business.copyFailed": "复制失败",
  "business.oneChangeRequired": "请至少填写价格、数量或有效期其中一项",
  "business.retryChanges": "修改失败，请稍后重试",
  "business.goodsLoadFailed": "商品加载失败",
  "business.retryGoodsLoad": "商品加载失败，请稍后重试",
  "business.sellerTitle": "我是货主",
  "business.image": "图片",
  "business.productName": "产品名称",
  "business.specPartNumber": "规格料号",
  "business.totalQuantity": "总数量",
  "business.remainingQuantity": "余量",
  "business.negotiator": "谈判人",
  "business.contact": "联系方式",
  "business.publishedAt": "发布时间",
  "business.action": "操作",
  "business.myInfo": "我的信息",
  "business.clueType": "线索类型",
  "business.selectType": "请选择类型",
  "business.title": "标题",
  "business.brand": "品牌",
  "business.unitPrice": "单价",
  "business.seller": "货主",
  "business.wechat": "微信",
  "business.mobile": "手机号",
  "business.clueStatus": "信息状态",
  "business.time": "时间",
  "business.draft": "草稿中",
  "business.pendingReview": "待审核",
  "business.reviewed": "已审核",
  "business.published": "已发布",
  "business.ended": "已终止",
  "business.supplyInfo": "货源信息",
  "business.buyRequestInfo": "求购信息",
  "business.all": "全部",
  "business.supply": "货源",
  "business.buyRequest": "求购",
  "business.myClues": "我发布的线索",
  "business.noData": "暂无数据",
  "business.noMore": "我们是有底线的",
  "business.currentStatus": "当前状态",
  "business.completeInfo": "资料完善",
  "business.details": "详情",
  "business.mySalesGoods": "我销售的商品",
  "business.biddingManagement": "竞标管理",
  "business.biddingList": "竞标列表",
  "business.bidExport.selectFirst": "请先勾选要导出的竞标数据",
  "business.bidExport.priceColumn": "下标价格",
  "business.bidExport.totalColumn": "总额",
  "business.bidExport.remarkColumn": "备注",
  "business.bidExport.filePrefix": "竞标下单",
  "business.bidExport.success": "已导出 {count} 条竞标数据",
  "business.bidExport.failed": "导出失败，请重试",
  "business.searchBidding": "搜索料号/品牌/编号",
  "business.card": "卡片",
  "business.list": "列表",
  "business.customerName": "客户名称",
  "business.bidQuantity": "竞标数量",
  "business.bidPrice": "竞标价格",
  "business.view": "查看",
  "business.noBidding": "暂无竞标信息",
  "business.bidNumber": "编号",
  "business.period": "期数",
  "business.type": "类型",
  "business.status": "状态",
  "business.biddingTime": "竞标时间",
  "business.noMoreBidding": "没有更多了",
  "business.publishBid": "发布竞标",
  "business.searchPublishedBid": "搜索料号、品牌、编号...",
  "business.referencePrice": "参考价",
  "business.edit": "修改",
  "business.delete": "删除",
  "business.noPublishedBid": "暂无发布竞标信息",
  "business.myBids": "我的竞标",
  "business.viewToggle": "视图切换",
  "business.cardView": "卡片视图",
  "business.listView": "列表视图",
  "business.switchCardView": "切换为卡片视图",
  "business.switchListView": "切换为列表视图",
  "business.searchBidProject": "搜索竞标项目",
  "business.allBids": "全部",
  "business.openBids": "竞标中",
  "business.closedBids": "已截标",
  "business.openedBids": "已开标",
  "business.wonBids": "已中标",
  "business.lostBids": "未中标",
  "business.productCategory": "产品分类",
  "business.technology": "技术",
  "business.capacity": "容量",
  "business.bidUnitPrice": "竞标单价",
  "business.editBid": "修改竞标",
  "business.editOnlyOpen": "仅竞标中可以修改",
  "business.statusAndId": "状态 / 编号",
  "business.productInfo": "产品信息",
  "business.goodsInfo": "货物信息",
  "business.timeInfo": "时间信息",
  "business.bidInfo": "竞标信息",
  "business.location": "所在地",
  "business.packaging": "包装",
  "business.package": "封装",
  "business.bidDeadline": "截标",
  "business.bidOpen": "开标",
  "business.level": "等级",
  "business.participants": "人数",
  "business.bidDialog.viewDetails": "查看详情",
  "business.bidDialog.favorite": "收藏竞标",
  "business.bidDialog.share": "分享竞标",
  "business.bidDialog.basicInfo": "基本信息",
  "business.bidDialog.stockLocation": "货所在地",
  "business.bidDialog.stock": "库存",
  "business.bidDialog.currency": "货币",
  "business.bidDialog.referenceUnitPrice": "参考单价",
  "business.bidDialog.quoteInfo": "竞价信息",
  "business.bidDialog.myQuote": "我的报价",
  "business.bidDialog.enterQuote": "请输入报价",
  "business.bidDialog.requiredQuantity": "需求数量",
  "business.bidDialog.maximum": "最大可输入：{count}",
  "business.bidDialog.submit": "提交竞价",
  "business.bidDialog.history": "竞价历史记录",
  "business.bidDialog.noHistory": "暂无竞价历史记录",
  "business.bidDialog.quote": "报价",
  "business.bidDialog.totalPrice": "货品总价",
  "business.bidDialog.commission": "佣金({percent}%·{mode})",
  "business.bidDialog.commissionLabel": "佣金",
  "business.bidDialog.payable": "应付",
  "business.bidDialog.deducted": "内扣",
  "business.bidDialog.added": "外加",
});

export const sharedUi = Object.freeze({
  "sharedUi.partNumberPrefix": "料号：",
  "sharedUi.added": "已添加",
  "sharedUi.item": "项目",
  "sharedUi.editSucceeded": "编辑成功",
  "sharedUi.completeRequired": "请检查并完善必填信息",
  "sharedUi.confirmationFailed": "确认失败",
  "sharedUi.skipLogin": "暂不登录",
  "sharedUi.closeDialog": "关闭{title}弹窗",
  "sharedUi.closeDetails": "关闭{title}",
});

export const sharedFlowUi = Object.freeze({
  "sharedUi.required": "必传",
  "sharedUi.optional": "选填",
});

export const messages = Object.freeze({
"loginBindings.bindTitle": "绑定{account}",
"loginBindings.bind": "去绑定",
"loginBindings.scan": "请使用微信扫描二维码完成绑定",
"loginBindings.country": "手机区号",
"loginBindings.code": "验证码",
"loginBindings.send": "获取验证码",
"loginBindings.confirm": "确认绑定",

"loginBindings.title": "登录绑定",
"loginBindings.phone": "手机号",
"loginBindings.email": "邮箱",
"loginBindings.wechat": "微信",
"loginBindings.wecom": "企业微信",
"loginBindings.google": "Google",
"loginBindings.bound": "已关联",
"loginBindings.unbound": "未关联",
"loginBindings.failed": "绑定信息加载失败",
"loginBindings.retry": "重试",

"passwordReset.phone": "手机号",
"passwordReset.email": "邮箱",
"passwordReset.smsCode": "短信验证码",
"passwordReset.emailCode": "邮箱验证码",

  "passwordReset.title": "忘记密码",
  "passwordReset.account": "手机号 / 邮箱",
  "passwordReset.code": "验证码",
  "passwordReset.send": "获取验证码",
  "passwordReset.resend": "{seconds}秒后重发",
  "passwordReset.password": "新密码（8至20位）",
  "passwordReset.confirmPassword": "确认新密码",
  "passwordReset.submit": "重置密码",
  "passwordReset.saving": "提交中",
  "passwordReset.invalidAccount": "请输入正确的手机号或邮箱",
  "passwordReset.invalidCode": "请输入4位数字验证码",
  "passwordReset.passwordLength": "密码长度需为8-20位",
  "passwordReset.mismatch": "两次输入的密码不一致",
  "passwordReset.sent": "验证码已发送",
  "passwordReset.success": "密码已重置，请使用新密码登录",
  "passwordReset.failed": "操作失败，请稍后重试",

  "authnMerge.regions": "实名认证短信目前仅支持中国大陆和中国香港，其他地区待接入。",
  "authnMerge.notice": "请使用本人手机号验证。若该手机号已有账号，提交后将合并登录身份至该账号并切换登录；不同身份或实名资料冲突时不会覆盖。",
  "recentFlow.receiptFailure": "收货操作失败，请重试",
  "recentFlow.batchInvalid": "发货批次数据异常，请重试",
  "recentFlow.historyFailure": "发货记录加载失败，请重试",
  "recentFlow.supplierQuantityInvalid": "商品订单ID必须有效，发货数量必须为正整数",
  "recentFlow.outboundQuantityInvalid": "商品订单、出库明细ID必须有效，发货数量必须为正整数，请重新查询出库单",
  "recentFlow.uploadPending": "发货凭证尚未上传完成，请等待上传完成后提交",

  "recentFlow.name": "商品名称",
  "recentFlow.brand": "品牌",
  "recentFlow.model": "料号",
  "recentFlow.price": "价格",
  "recentFlow.quantity": "数量",
  "recentFlow.code": "商品编号",
  "recentFlow.placed": "已下单",
  "recentFlow.processing": "做单中",
  "recentFlow.completed": "已完成",
  "recentFlow.purchase": "采购",
  "recentFlow.sales": "销售",

  "recentFlow.confirm": "确认收货",
  "recentFlow.orderNumber": "订单号：",
  "recentFlow.hint": "请核对每批物流及商品数量，按实际到货批次确认收货。",
  "recentFlow.loading": "正在加载发货数据…",
  "recentFlow.reload": "重新加载",
  "recentFlow.empty": "暂无发货批次",
  "recentFlow.received": "已收货",
  "recentFlow.waiting": "待收货",
  "recentFlow.shippedAt": "发货时间",
  "recentFlow.company": "物流公司",
  "recentFlow.tracking": "物流单号",
  "recentFlow.remark": "发货备注",
  "recentFlow.receivedAt": "收货时间",
  "recentFlow.modelMissing": "未填写型号",
  "recentFlow.unit": "件",
  "recentFlow.voucher": "发货凭证",
  "recentFlow.close": "关闭",
  "recentFlow.loadFailed": "发货数据加载失败，请重试",
  "recentFlow.resultInvalid": "收货结果异常，请重新加载核实",
  "recentFlow.success": "该批次确认收货成功",
  "recentFlow.failed": "确认收货失败，请重试",
  "recentFlow.submitting": "提交中",
  "recentFlow.submitSettlement": "提交结单",
  "recentFlow.ordersLoading": "订单加载中",
  "recentFlow.ordersEmpty": "暂无关联订单",
  "recentFlow.ordersFailed": "关联订单查询失败",
  "recentFlow.specFailed": "商品规格加载失败",
  "recentFlow.splitFailed": "拆单失败",
  "recentFlow.wholeSuccess": "整单设置成功",
  "recentFlow.splitSuccess": "拆单成功",
  "recentFlow.splitRetry": "拆单失败，请稍后重试",
  "recentFlow.confirmWhole": "确认整单",
  "recentFlow.confirmSplit": "确认拆单",
  "recentFlow.wholeHint": "整单可调整各规格现价后填写买家手机号提交",
  "recentFlow.splitHint": "填写买家手机号，勾选规格后确认现价和拆单数量",
  "recentFlow.batchTitle": "第 {count} 批发货",
  "recentFlow.specifications": "个规格",

  "bulkShipping.uploadFailed": "物流信息上传失败，请稍后重试",
  "mobilePublish.itemTitle": "商品 {count}",
  "mobilePublish.copy": "复制",
  "mobilePublish.remove": "删除",
  "mobilePublish.addItem": "添加商品",
  "mobileQuickOrder.waitForGoods": "请等待商品信息加载完成后重试",
  "mobileQuickOrder.detailsFailed": "商品明细加载失败，请刷新后重试",
  "mobileQuickOrder.specificationsChanged": "商品规格已变更，请返回商品详情重新选择",

  ...sharedFlowUi,
  ...sharedUi,
  ...base,
  ...merged20261021,
  ...formDisplay,
  ...catalogDisplay,
  ...systemFeedback,
  ...business,
});

// 语言菜单使用各语言自称，不随当前界面语言更改。
export const languageNames = Object.freeze({
  "zh-CN": "简体中文",
  "zh-HK": "繁體中文（香港）",
  "en-US": "English",
});
